var map = {
	"./2025/1000Icon.png": 345,
	"./2025/1400Icon.png": 346,
	"./2025/1600Icon.png": 347,
	"./2025/900Icon.png": 348,
	"./2025/arrow.gif": 23,
	"./2025/arrow_next.png": 349,
	"./2025/arrow_next2.png": 137,
	"./2025/black-arrow-gif.gif": 1242,
	"./2025/black-arrow.png": 1243,
	"./2025/blue-arrow.gif": 1244,
	"./2025/multiplayerIcon.png": 350,
	"./2025/nextTopic_bg.png": 1245,
	"./2025/topic1000/a_video.png": 1246,
	"./2025/topic1000/a_video_mobile.png": 1247,
	"./2025/topic1000/background-1.png": 1248,
	"./2025/topic1000/background-2.png": 1249,
	"./2025/topic1000/background-3.png": 1250,
	"./2025/topic1000/background-4-mobile.png": 1251,
	"./2025/topic1000/background-4.png": 1252,
	"./2025/topic1000/background-5-1.png": 1253,
	"./2025/topic1000/background-6.png": 351,
	"./2025/topic1000/computer-mobile.png": 352,
	"./2025/topic1000/computer.png": 353,
	"./2025/topic1000/ele_example_1_1.png": 354,
	"./2025/topic1000/ele_example_2_1.png": 355,
	"./2025/topic1000/ele_example_2_2.png": 356,
	"./2025/topic1000/ele_example_3_1.png": 357,
	"./2025/topic1000/ele_example_3_2.png": 358,
	"./2025/topic1000/ele_example_4_1.png": 359,
	"./2025/topic1000/ele_example_4_2.png": 360,
	"./2025/topic1000/ele_example_4_3.png": 361,
	"./2025/topic1000/example_img_1_1.png": 362,
	"./2025/topic1000/example_img_1_2.png": 363,
	"./2025/topic1000/example_img_1_3.png": 364,
	"./2025/topic1000/example_img_1_4.png": 365,
	"./2025/topic1000/example_img_1_5.png": 366,
	"./2025/topic1000/example_img_1_6.png": 367,
	"./2025/topic1000/example_img_1_6_1.png": 368,
	"./2025/topic1000/example_img_1_7.png": 1254,
	"./2025/topic1000/example_img_1_7_1.png": 369,
	"./2025/topic1000/person-back.png": 1255,
	"./2025/topic1000/person-cover.png": 1256,
	"./2025/topic1000/person.png": 1257,
	"./2025/topic1000/quiz_bg.png": 1258,
	"./2025/topic1000/quiz_bg_mobile.png": 1259,
	"./2025/topic1000/section2_4_1.png": 1260,
	"./2025/topic1000/section2_4_3.png": 1261,
	"./2025/topic1000/section2_4_3_m.png": 1262,
	"./2025/topic1000/section2_back.png": 1263,
	"./2025/topic1000/section3_1_0.png": 370,
	"./2025/topic1000/section3_1_1.png": 1264,
	"./2025/topic1000/section3_1_2.png": 371,
	"./2025/topic1000/section3_2_1.png": 372,
	"./2025/topic1000/section3_2_1_cn.png": 373,
	"./2025/topic1000/section3_2_1_sc.png": 374,
	"./2025/topic1000/section3_3_1.png": 375,
	"./2025/topic1000/section3_3_2.png": 376,
	"./2025/topic1000/section3_3_2_m.png": 377,
	"./2025/topic1000/section3_4_1.png": 1265,
	"./2025/topic1000/section3_back.png": 1266,
	"./2025/topic1000/section4/arrow-circle.png": 1267,
	"./2025/topic1000/section4/arrow.png": 1268,
	"./2025/topic1000/section4/background-1.png": 1269,
	"./2025/topic1000/section4/background-2.png": 1270,
	"./2025/topic1000/section4/background-3-mobile.png": 1271,
	"./2025/topic1000/section4/background-3.png": 1272,
	"./2025/topic1000/section4/background-4.png": 1273,
	"./2025/topic1000/section4/background-5.png": 1274,
	"./2025/topic1000/section4/background-6.png": 1275,
	"./2025/topic1000/section4/black-arrow.png": 1276,
	"./2025/topic1000/section4/computer-icon.png": 1277,
	"./2025/topic1000/section4/dialog-box-1-en.png": 1278,
	"./2025/topic1000/section4/dialog-box-1-mobile.png": 1279,
	"./2025/topic1000/section4/dialog-box-1.png": 1280,
	"./2025/topic1000/section4/dialog-box-2-en.png": 1281,
	"./2025/topic1000/section4/dialog-box-2-mobile.png": 1282,
	"./2025/topic1000/section4/dialog-box-2.png": 1283,
	"./2025/topic1000/section4/dialog-box-3-mobile.png": 1284,
	"./2025/topic1000/section4/dialog-box-3.png": 1285,
	"./2025/topic1000/section4/dialog-box-4-mobile.png": 1286,
	"./2025/topic1000/section4/dialog-box-4.png": 1287,
	"./2025/topic1000/section5/background-1.png": 1288,
	"./2025/topic1000/section5/background-2.png": 1289,
	"./2025/topic1000/section5/background-3.png": 1290,
	"./2025/topic1000/section5/blue-box.png": 1291,
	"./2025/topic1000/section5/bottom-decoration.png": 1292,
	"./2025/topic1000/section5/flower-computer.png": 1293,
	"./2025/topic1000/section5/orange-box.png": 1294,
	"./2025/topic1000/section5/persons.png": 1295,
	"./2025/topic1000/spot1.png": 1296,
	"./2025/topic1000/spot2.png": 1297,
	"./2025/topic1000/spot3.png": 1298,
	"./2025/topic1000/warning.png": 1299,
	"./2025/topic1400/elePerson_2_1.png": 378,
	"./2025/topic1400/elePerson_2_2.png": 379,
	"./2025/topic1400/file_bg.png": 1300,
	"./2025/topic1400/file_bg_m.png": 1301,
	"./2025/topic1400/file_bg_m2.png": 1302,
	"./2025/topic1400/file_left_person.png": 380,
	"./2025/topic1400/file_right_img.png": 381,
	"./2025/topic1400/left_icon.svg": 1303,
	"./2025/topic1400/line_left_bg.png": 1304,
	"./2025/topic1400/line_right_bg.png": 1305,
	"./2025/topic1400/news_bg.png": 1306,
	"./2025/topic1400/practice_img.png": 382,
	"./2025/topic1400/practice_left_bg.png": 383,
	"./2025/topic1400/quiz_bg.png": 1307,
	"./2025/topic1400/quiz_bg_mobile.png": 1308,
	"./2025/topic1400/right_icon.png": 384,
	"./2025/topic1400/risk_person.png": 385,
	"./2025/topic1400/section3_3_1.png": 386,
	"./2025/topic1400/section3_3_2.png": 387,
	"./2025/topic1400/section3_3_2_m.png": 388,
	"./2025/topic1400/shared_file_bg.png": 1309,
	"./2025/topic1400/shared_file_bg1.png": 1310,
	"./2025/topic1400/shared_file_bg2.png": 1311,
	"./2025/topic1400/shared_left_bottom.png": 185,
	"./2025/topic1400/top_bg.png": 1312,
	"./2025/topic1400/top_ele1.png": 1313,
	"./2025/topic1400/top_flowers.png": 389,
	"./2025/topic1400/top_icon.png": 1314,
	"./2025/topic1400/top_person.png": 390,
	"./2025/topic1400/top_tips.png": 1315,
	"./2025/topic1400/wrong_icon.png": 391,
	"./2025/topic1600/background-1.png": 1316,
	"./2025/topic1600/background-2.png": 1317,
	"./2025/topic1600/background-3.png": 1318,
	"./2025/topic1600/background-4.png": 1319,
	"./2025/topic1600/background-5-1.png": 1320,
	"./2025/topic1600/background-5.png": 1321,
	"./2025/topic1600/background-6-mobile.png": 1322,
	"./2025/topic1600/background-6.png": 1323,
	"./2025/topic1600/computer.png": 1324,
	"./2025/topic1600/connect-vpn-1.png": 1325,
	"./2025/topic1600/connect-vpn-2.png": 1326,
	"./2025/topic1600/example-1.png": 392,
	"./2025/topic1600/flower-1.png": 1327,
	"./2025/topic1600/flower.png": 1328,
	"./2025/topic1600/header-icon.png": 1329,
	"./2025/topic1600/info-lock.png": 1330,
	"./2025/topic1600/person-1.png": 1331,
	"./2025/topic1600/person-2.png": 1332,
	"./2025/topic1600/person.png": 1333,
	"./2025/topic1600/quiz_bg.png": 1334,
	"./2025/topic1600/quiz_bg_mobile.png": 1335,
	"./2025/topic1600/right-icon.png": 1336,
	"./2025/topic1600/section2_7.png": 393,
	"./2025/topic1600/section2_7_1.png": 394,
	"./2025/topic1600/section2_7_mobile.png": 395,
	"./2025/topic1600/section2_8.png": 396,
	"./2025/topic1600/section2_81.png": 397,
	"./2025/topic1600/section2_9.png": 398,
	"./2025/topic1600/silkRibbon-1.png": 1337,
	"./2025/topic1600/silkRibbon-2.png": 1338,
	"./2025/topic1600/transfer-arrow.png": 1339,
	"./2025/topic1600/vpn-background-1-mobile.png": 1340,
	"./2025/topic1600/vpn-background-1.png": 1341,
	"./2025/topic1600/vpn-background-2-mobile.png": 1342,
	"./2025/topic1600/vpn-background-2.png": 1343,
	"./2025/topic1600/wave.png": 1344,
	"./2025/topic1600/wrong-icon.png": 1345,
	"./2025/topic900/CenterCircle.png": 399,
	"./2025/topic900/arrow_orange_left.png": 1346,
	"./2025/topic900/arrow_r.png": 1347,
	"./2025/topic900/back_1_3.png": 1348,
	"./2025/topic900/back_1_3_m.png": 400,
	"./2025/topic900/back_lines1.png": 1349,
	"./2025/topic900/back_pad1.png": 1350,
	"./2025/topic900/back_piece1.5.png": 1351,
	"./2025/topic900/bottom_left.png": 1352,
	"./2025/topic900/code_icon1.png": 401,
	"./2025/topic900/code_icon2.png": 402,
	"./2025/topic900/code_icon3.png": 403,
	"./2025/topic900/code_icon4.png": 404,
	"./2025/topic900/code_icon5.png": 405,
	"./2025/topic900/code_icon6.png": 406,
	"./2025/topic900/correct_icon.png": 186,
	"./2025/topic900/eleImg_pwd_2_1.png": 1353,
	"./2025/topic900/eleImg_pwd_2_2.png": 1354,
	"./2025/topic900/eleImg_pwd_2_3.png": 1355,
	"./2025/topic900/eleImg_pwd_2_4.png": 1356,
	"./2025/topic900/elePerson1-1.png": 407,
	"./2025/topic900/elePerson_2_1.png": 187,
	"./2025/topic900/elePerson_2_2.png": 188,
	"./2025/topic900/elePerson_2_3.png": 408,
	"./2025/topic900/elePerson_2_4.png": 409,
	"./2025/topic900/ele_Preson_3_2.png": 1357,
	"./2025/topic900/ele_Preson_3_2_m.png": 1358,
	"./2025/topic900/ele_icon_lock.png": 1359,
	"./2025/topic900/en_img.png": 410,
	"./2025/topic900/error_icon.png": 189,
	"./2025/topic900/flower.png": 1360,
	"./2025/topic900/icon1-1.png": 1361,
	"./2025/topic900/icon_clock1.png": 1362,
	"./2025/topic900/icon_correct.png": 1363,
	"./2025/topic900/icon_error.png": 1364,
	"./2025/topic900/icon_flower1.png": 1365,
	"./2025/topic900/icon_text1.png": 1366,
	"./2025/topic900/icon_text2.png": 1367,
	"./2025/topic900/line_bg_2.png": 1368,
	"./2025/topic900/pwd_type1.png": 165,
	"./2025/topic900/pwd_type2.png": 166,
	"./2025/topic900/pwd_type_3_1.png": 245,
	"./2025/topic900/pwd_type_3_3.png": 246,
	"./2025/topic900/pwd_type_3_4.png": 212,
	"./2025/topic900/pwd_type_3_4_1.png": 411,
	"./2025/topic900/quiz_bg.png": 1369,
	"./2025/topic900/quiz_bg_mobile.png": 1370,
	"./2025/topic900/step/step1.png": 616,
	"./2025/topic900/step/step2.png": 617,
	"./2025/topic900/step/step3.png": 618,
	"./2025/topic900/step/step4.png": 619,
	"./2025/topic900/tab/item_bg1.png": 1371,
	"./2025/topic900/tab/item_bg2.png": 1372,
	"./2025/topic900/tab/item_bg3.png": 1373,
	"./2025/topic900/tab/person_tab.png": 412,
	"./2025/topic900/tab/tab1_1.png": 620,
	"./2025/topic900/tab/tab1_2.png": 621,
	"./2025/topic900/tab/tab2_1.png": 622,
	"./2025/topic900/tab/tab2_2.png": 623,
	"./2025/topic900/tab/tab2_3.png": 624,
	"./2025/topic900/tab/tab3_1.png": 625,
	"./2025/topic900/tab/tab3_2.png": 626,
	"./2025/topic900/verify/verify_bg1.png": 627,
	"./2025/topic900/verify/verify_bg2.png": 628,
	"./2025/topic900/verify/verify_bg3.png": 629,
	"./2025/topic900/verify/verify_bg4.png": 630,
	"./2025/topic900/verify/verify_icon1.png": 631,
	"./2025/topic900/verify/verify_icon2.png": 632,
	"./2025/topic900/verify/verify_icon3.png": 633,
	"./2025/topic900/verify/verify_icon4.png": 634,
	"./2025/topic900/video_3people.png": 1374,
	"./2025/topic900/video_3people_m.png": 1375,
	"./2025/topicQuiz/answer_left.png": 413,
	"./2025/topicQuiz/firework.png": 1376,
	"./2025/topicQuiz/left_test.png": 414,
	"./2025/topicQuiz/not_pass.png": 415,
	"./2025/topicQuiz/pass.png": 416,
	"./2025/topicQuiz/quiz_bg.png": 1377,
	"./2025/topicQuiz/quiz_bg_1.png": 1378,
	"./2025/wPeople1.png": 1379,
	"./2025/wPeople2.png": 1380,
	"./2025/welcomeBg.png": 1381,
	"./2025/welcomeBg_m.png": 1382,
	"./2025/welcomeInfo.png": 1383,
	"./2025/welcomeStarrt.png": 1384,
	"./2025/welcome_bg_left.png": 1385,
	"./3d-speech-bubble.png": 1386,
	"./817w2.png": 417,
	"./817w3.png": 418,
	"./9881.png": 1387,
	"./9882.png": 1388,
	"./Artboard 20 1.svg": 1389,
	"./Artboard 20 2.svg": 1390,
	"./Boss-right.png": 1391,
	"./CSRealCase1-en-moblie.jpg": 635,
	"./CSRealCase1-en.jpg": 636,
	"./CSRealCase1-moblie.jpg": 637,
	"./CSRealCase1.jpg": 638,
	"./CSRealCase1.png": 1392,
	"./CSRealCase2-en-moblie.jpg": 639,
	"./CSRealCase2-en.jpg": 640,
	"./CSRealCase2-moblie.jpg": 641,
	"./CSRealCase2.jpg": 642,
	"./CSRealCase3-en-moblie.jpg": 643,
	"./CSRealCase3-en.jpg": 644,
	"./CSRealCase3-moblie.jpg": 645,
	"./CSRealCase3.jpg": 646,
	"./CommonInternetWhalingAttacks1.jpg": 647,
	"./CommonInternetWhalingAttacks1.png": 1393,
	"./CommonInternetWhalingAttacks2.jpg": 648,
	"./CommonInternetWhalingAttacks2.png": 1394,
	"./CommonInternetWhalingAttacks3.jpg": 649,
	"./CommonInternetWhalingAttacks3.png": 1395,
	"./CommonInternetWhalingAttacks4.jpg": 650,
	"./CommonInternetWhalingAttacks4.png": 1396,
	"./CustomerRealCase1-en-moblie.jpg": 651,
	"./CustomerRealCase1-en.jpg": 652,
	"./CustomerRealCase1-moblie.jpg": 653,
	"./CustomerRealCase1.jpg": 654,
	"./E-commerce-gif1.gif": 1397,
	"./E-commerce-gif2.gif": 1398,
	"./E-commerce-gif3.gif": 1399,
	"./E-commerce-gif4.gif": 1400,
	"./E-commerceRealCase1-en.jpg": 655,
	"./E-commerceRealCase1-moblie-en.jpg": 656,
	"./E-commerceRealCase1-moblie.jpg": 657,
	"./E-commerceRealCase1.jpg": 658,
	"./E-commerceRealCase2-en.jpg": 659,
	"./E-commerceRealCase2-mobile.jpg": 660,
	"./E-commerceRealCase2-moblie-en.jpg": 661,
	"./E-commerceRealCase2-moblie.jpg": 662,
	"./E-commerceRealCase2.jpg": 663,
	"./Finance.png": 419,
	"./FinanceRealCase-en.jpg": 664,
	"./FinanceRealCase-mobile-en.jpg": 665,
	"./FinanceRealCase-mobile-sc.jpg": 666,
	"./FinanceRealCase-mobile.jpg": 667,
	"./FinanceRealCase-sc.jpg": 668,
	"./FinanceRealCase.jpg": 669,
	"./FinanceRealCase.png": 1401,
	"./FinanceRealCase2-en.jpg": 670,
	"./FinanceRealCase2-mobile-en.jpg": 671,
	"./FinanceRealCase2-mobile-sc.jpg": 672,
	"./FinanceRealCase2-mobile.jpg": 673,
	"./FinanceRealCase2-sc.jpg": 674,
	"./FinanceRealCase2.jpg": 675,
	"./G5584.png": 1402,
	"./Group5600.png": 1403,
	"./HRRealCase-en.jpg": 676,
	"./HRRealCase-mobile-en.jpg": 677,
	"./HRRealCase-mobile.jpg": 678,
	"./HRRealCase.jpg": 679,
	"./IT.png": 420,
	"./ITRealCase.svg": 1404,
	"./ITRealCase1-en.jpg": 680,
	"./ITRealCase1-moblie-en.jpg": 681,
	"./ITRealCase1-moblie.jpg": 682,
	"./ITRealCase1.jpg": 683,
	"./ITRealCase2-en.jpg": 684,
	"./ITRealCase2-moblie-en.jpg": 685,
	"./ITRealCase2-moblie.jpg": 686,
	"./ITRealCase2.jpg": 687,
	"./ITRealCase3-en.jpg": 688,
	"./ITRealCase3-moblie-en.jpg": 689,
	"./ITRealCase3-moblie.jpg": 690,
	"./ITRealCase3.jpg": 691,
	"./IndexPrompt.jpg": 692,
	"./IndexPrompt.png": 1405,
	"./Introduction.png": 1406,
	"./Lady.svg": 1407,
	"./Link.png": 190,
	"./Ma009-1.svg": 1408,
	"./Ma009-2.svg": 1409,
	"./Ma009-3.svg": 1410,
	"./Ma009-4.svg": 1411,
	"./Ma009-5.svg": 1412,
	"./Ma009-6.svg": 1413,
	"./Manufacturing.png": 1414,
	"./MarketRealCase.jpg": 693,
	"./MarketRealCase1-en-moblie.jpg": 694,
	"./MarketRealCase1-en.jpg": 695,
	"./MarketRealCase1-moblie.jpg": 696,
	"./MarketRealCase1.jpg": 697,
	"./MarketRealCase1.png": 1415,
	"./MarketRealCase1.svg": 1416,
	"./MarketRealCase2-en-moblie.jpg": 698,
	"./MarketRealCase2-en.jpg": 699,
	"./MarketRealCase2-moblie.jpg": 700,
	"./MarketRealCase2.jpg": 701,
	"./MarketRealCase3-en.jpg": 702,
	"./Mc001-Picture1.png": 1417,
	"./Mc001-Picture2.png": 1418,
	"./Mc001-Picture3.png": 1419,
	"./NGORealCase1-en.jpg": 703,
	"./NGORealCase1-moblie-en.jpg": 704,
	"./NGORealCase1-moblie.jpg": 705,
	"./NGORealCase1.jpg": 706,
	"./NGORealCase2-en.jpg": 707,
	"./NGORealCase2-moblie-en.jpg": 708,
	"./NGORealCase2-moblie.jpg": 709,
	"./NGORealCase2.jpg": 710,
	"./PPII.png": 1420,
	"./Pictureds1.png": 1421,
	"./Pictureds10.png": 1422,
	"./Pictureds2.png": 1423,
	"./Pictureds3.png": 1424,
	"./Pictureds4.png": 1425,
	"./Pictureds5.png": 1426,
	"./Pictureds6.png": 1427,
	"./Pictureds7.png": 1428,
	"./Pictureds8.png": 1429,
	"./Pictureds9.png": 1430,
	"./PwC_Repre_Illus_Iso_02_IoT_RGB.png": 1431,
	"./PwC_Repre_Illus_Iso_05_Chatbot_RGB.png": 1432,
	"./RealCase-en.png": 1433,
	"./RealCase-mobile-en.jpg": 711,
	"./RealCase-mobile-sc.jpg": 712,
	"./RealCase-sc.jpg": 713,
	"./RealCase.mobile.jpg": 714,
	"./RealCase.png": 1434,
	"./Realcase-socialMedia-en.png": 1435,
	"./Realcase-socialMedia-mobile-en.png": 1436,
	"./Realcase-socialMedia-mobile.jpg": 715,
	"./Realcase-socialMedia.jpg": 716,
	"./Shield.png": 421,
	"./Software-Downloading-icon1.png": 1437,
	"./Software-Downloading-icon2.png": 1438,
	"./Software-Downloading-icon3.png": 1439,
	"./Software-Downloading-icon4.png": 1440,
	"./Software-Downloading-img1.png": 1441,
	"./Software-Downloading-img2.png": 1442,
	"./Software-Downloading-img3.png": 1443,
	"./Software-Downloading-img4.png": 1444,
	"./a001-01.svg": 1445,
	"./a001-02.svg": 1446,
	"./a001-03.svg": 1447,
	"./a001-04.svg": 1448,
	"./a001-05.svg": 1449,
	"./a001-06.svg": 1450,
	"./a001-ransomware-01.png": 1451,
	"./a001-ransomware-02.png": 1452,
	"./a001-ransomware-03.png": 1453,
	"./a001-ransomware-04.png": 1454,
	"./a001-whatsapp-01.png": 1455,
	"./a001-whatsapp-02.png": 1456,
	"./a001-whatsapp-03.png": 1457,
	"./a004-a.jpg": 717,
	"./a004-b.jpg": 718,
	"./a004-example1-en.jpg": 719,
	"./a004-example1-sc.jpg": 720,
	"./a004-example1.jpg": 721,
	"./a004-example2.jpg": 722,
	"./a004-example3.jpg": 723,
	"./a004-mary-left.svg": 1458,
	"./a005-5.png": 1459,
	"./a005-6.png": 1460,
	"./a005-general2024.png": 1461,
	"./a006-a.png": 1462,
	"./a006-b.png": 1463,
	"./a006-c.png": 1464,
	"./a008-1.png": 1465,
	"./a008-1.svg": 1466,
	"./a008-2.png": 1467,
	"./a008-2.svg": 1468,
	"./a008-3.png": 1469,
	"./a008-3.svg": 1470,
	"./a008-4.png": 1471,
	"./a008-4.svg": 1472,
	"./a008-5.png": 1473,
	"./a008-5.svg": 1474,
	"./a008-6.svg": 1475,
	"./a008-7.svg": 1476,
	"./a008-A.svg": 1477,
	"./a008-B.svg": 1478,
	"./a008-C.svg": 1479,
	"./a008-D.svg": 1480,
	"./a008-tip.jpg": 724,
	"./a009-1.png": 1481,
	"./a009-1.svg": 1482,
	"./a009-2.png": 1483,
	"./a009-2.svg": 1484,
	"./a009-3.png": 1485,
	"./a009-3.svg": 1486,
	"./a009-4.png": 1487,
	"./a009-4.svg": 1488,
	"./a009-5.svg": 1489,
	"./a009-6.svg": 1490,
	"./a009-ransomware-01.svg": 1491,
	"./a009-ransomware-02.svg": 1492,
	"./a009-ransomware-03.svg": 1493,
	"./a009-ransomware-04.svg": 1494,
	"./a009-tip1.jpg": 725,
	"./a009-tip2.jpg": 726,
	"./a009-tip3.jpg": 727,
	"./a010-1.png": 1495,
	"./a010-2.png": 1496,
	"./a010-3.png": 1497,
	"./a010-4.png": 1498,
	"./a011-01.jpg": 728,
	"./a011-010.jpg": 729,
	"./a011-011.jpg": 730,
	"./a011-012.jpg": 731,
	"./a011-02.jpg": 732,
	"./a011-03.jpg": 733,
	"./a011-04.jpg": 734,
	"./a011-05.jpg": 735,
	"./a011-06.jpg": 736,
	"./a011-07.jpg": 737,
	"./a011-08.jpg": 738,
	"./a011-09.jpg": 739,
	"./a011-1.png": 1499,
	"./a011-1.svg": 1500,
	"./a011-2.png": 1501,
	"./a011-2.svg": 1502,
	"./a011-3.png": 1503,
	"./a011-3.svg": 1504,
	"./a011-4.png": 1505,
	"./a011-4.svg": 1506,
	"./a011-5.png": 1507,
	"./a011-5.svg": 1508,
	"./a011-6.png": 1509,
	"./a011-6.svg": 1510,
	"./a011-7.svg": 1511,
	"./a011-PPII-1.svg": 1512,
	"./a011-PPII-2.svg": 1513,
	"./a011-PPII-3.svg": 1514,
	"./a011-PPII-4.svg": 1515,
	"./a011-PPII-5.svg": 1516,
	"./a011-PPII-6.svg": 1517,
	"./a011-example1.jpg": 740,
	"./a011-example10.png": 1518,
	"./a011-example11_en.png": 1519,
	"./a011-example11_sc.png": 1520,
	"./a011-example11_tc.png": 1521,
	"./a011-example13_en.png": 1522,
	"./a011-example13_sc.png": 1523,
	"./a011-example13_tc.png": 1524,
	"./a011-example2.jpg": 741,
	"./a011-example3.jpg": 742,
	"./a011-example4.png": 1525,
	"./a011-example5.jpg": 743,
	"./a011-example6.jpg": 744,
	"./a011-example7.jpg": 745,
	"./a011-example8.jpg": 746,
	"./a011-example9.png": 1526,
	"./a011-fsi-01.svg": 1527,
	"./a011-fsi-02.svg": 1528,
	"./a011-fsi-03.svg": 1529,
	"./a011-fsi-04.svg": 1530,
	"./a011-fsi-05.svg": 1531,
	"./a011-fsi-06.svg": 1532,
	"./a011-fsi-07.svg": 1533,
	"./a011-fsi-08.svg": 1534,
	"./a011-fsi-09.svg": 1535,
	"./a011-fsi-10.svg": 1536,
	"./a011-general2024-example1.png": 1537,
	"./a011-general2024-example2.png": 1538,
	"./a011-general2024-example3.png": 1539,
	"./a011-general2024-example4.png": 1540,
	"./a011-market-1.svg": 1541,
	"./a011-market-2.svg": 1542,
	"./a011-market-3.svg": 1543,
	"./a011-market-4.svg": 1544,
	"./a011-market-5.svg": 1545,
	"./a011-market-6.svg": 1546,
	"./a011-startup-01.svg": 1547,
	"./a011-startup-02.svg": 1548,
	"./a011-startup-03.svg": 1549,
	"./a011-startup-04.svg": 1550,
	"./a011-startup-05.svg": 1551,
	"./a011-startup-06.svg": 1552,
	"./a011-startup-1.svg": 1553,
	"./a011-startup-2.svg": 1554,
	"./a011-startup-3.svg": 1555,
	"./a011-startup-4.svg": 1556,
	"./a011-startup-5.svg": 1557,
	"./a012-1.png": 1558,
	"./a012-1.svg": 1559,
	"./a012-10.png": 1560,
	"./a012-10.svg": 1561,
	"./a012-11.png": 1562,
	"./a012-12.png": 1563,
	"./a012-13.png": 1564,
	"./a012-14.png": 1565,
	"./a012-15.png": 1566,
	"./a012-2.png": 1567,
	"./a012-2.svg": 1568,
	"./a012-3.png": 1569,
	"./a012-3.svg": 1570,
	"./a012-4.png": 1571,
	"./a012-4.svg": 1572,
	"./a012-5.png": 1573,
	"./a012-5.svg": 1574,
	"./a012-6.png": 1575,
	"./a012-6.svg": 1576,
	"./a012-7.png": 1577,
	"./a012-7.svg": 1578,
	"./a012-8.png": 1579,
	"./a012-8.svg": 1580,
	"./a012-9.png": 1581,
	"./a012-9.svg": 1582,
	"./a012-market-1.svg": 1583,
	"./a012-market-10.svg": 1584,
	"./a012-market-2.svg": 1585,
	"./a012-market-3.svg": 1586,
	"./a012-market-4.svg": 1587,
	"./a012-market-5.svg": 1588,
	"./a012-market-6.svg": 1589,
	"./a012-market-7.svg": 1590,
	"./a012-market-8.svg": 1591,
	"./a012-market-9.svg": 1592,
	"./a012-market-line-1.svg": 1593,
	"./a012-market-line-10.svg": 1594,
	"./a012-market-line-2.svg": 1595,
	"./a012-market-line-3.svg": 1596,
	"./a012-market-line-4.svg": 1597,
	"./a012-market-line-5.svg": 1598,
	"./a012-market-line-6.svg": 1599,
	"./a012-market-line-7.svg": 1600,
	"./a012-market-line-8.svg": 1601,
	"./a012-market-line-9.svg": 1602,
	"./a013-1.png": 1603,
	"./a013-2.png": 1604,
	"./a013-3.png": 1605,
	"./a013-4.png": 1606,
	"./a013-a.png": 1607,
	"./a013-b.png": 1608,
	"./a013-c.png": 1609,
	"./a013-d.png": 1610,
	"./a014-long.svg": 1611,
	"./a014-longer.svg": 1612,
	"./a014.svg": 1613,
	"./a015-1.svg": 1614,
	"./a015-2.svg": 1615,
	"./a015-3.svg": 1616,
	"./a015-4.svg": 1617,
	"./a015-arrow.svg": 191,
	"./a016-1.jpg": 747,
	"./a016-2.jpg": 748,
	"./a016-3.jpg": 749,
	"./a016-4.jpg": 750,
	"./a016-4.png": 1618,
	"./a016-5.jpg": 751,
	"./a016-5.png": 1619,
	"./a016-6.jpg": 752,
	"./a016-6.png": 1620,
	"./a016-7.png": 1621,
	"./a016-8.png": 1622,
	"./a016-attention-market.svg": 192,
	"./a016-attention.svg": 193,
	"./a016-market-1.jpg": 753,
	"./a016-market-2.jpg": 754,
	"./a016-market-3.jpg": 755,
	"./a016-market-4.jpg": 756,
	"./a017-1.svg": 1623,
	"./a017-10.svg": 1624,
	"./a017-2.svg": 1625,
	"./a017-3.svg": 1626,
	"./a017-4.svg": 1627,
	"./a017-5.svg": 1628,
	"./a017-6.svg": 1629,
	"./a017-7.svg": 1630,
	"./a017-8.svg": 1631,
	"./a017-9.svg": 1632,
	"./a017-a.svg": 1633,
	"./a017-b.svg": 1634,
	"./a017-c.svg": 1635,
	"./a017-d.svg": 1636,
	"./a017-e.svg": 1637,
	"./a017-f.svg": 1638,
	"./a017-g.svg": 1639,
	"./a017-h.svg": 1640,
	"./a017-i.svg": 1641,
	"./a017-j.svg": 1642,
	"./a017-line1.svg": 1643,
	"./a017-line10.svg": 1644,
	"./a017-line2.svg": 1645,
	"./a017-line3.svg": 1646,
	"./a017-line4.svg": 1647,
	"./a017-line5.svg": 1648,
	"./a017-line6.svg": 1649,
	"./a017-line7.svg": 1650,
	"./a017-line8.svg": 1651,
	"./a017-line9.svg": 1652,
	"./a017-market-1.svg": 1653,
	"./a017-market-10.svg": 1654,
	"./a017-market-2.svg": 1655,
	"./a017-market-3.svg": 1656,
	"./a017-market-4.svg": 1657,
	"./a017-market-5.svg": 1658,
	"./a017-market-6.svg": 1659,
	"./a017-market-7.svg": 1660,
	"./a017-market-8.svg": 1661,
	"./a017-market-9.svg": 1662,
	"./a018-1.svg": 1663,
	"./a018-10.svg": 1664,
	"./a018-2.svg": 1665,
	"./a018-3.svg": 1666,
	"./a018-4.svg": 1667,
	"./a018-5.svg": 1668,
	"./a018-6.svg": 1669,
	"./a018-7.svg": 1670,
	"./a018-8.svg": 1671,
	"./a018-9.svg": 1672,
	"./a019-1.svg": 1673,
	"./a019-2.svg": 1674,
	"./a019-3.svg": 1675,
	"./a019-4.svg": 1676,
	"./a019-5.svg": 1677,
	"./a019-tip-en.jpg": 757,
	"./a019-tip.jpg": 758,
	"./a019.gif": 1678,
	"./a020-cs-1.svg": 1679,
	"./a020-cs-2.svg": 1680,
	"./a020-cs-3.svg": 1681,
	"./a020-cs-4.svg": 1682,
	"./a020-it-1.svg": 1683,
	"./a020-it-2.svg": 1684,
	"./a020-it-3.svg": 1685,
	"./a020-it-4.svg": 1686,
	"./a020-market-1.svg": 1687,
	"./a020-market-2.svg": 1688,
	"./a020-market-3.svg": 1689,
	"./a020-market-4.svg": 1690,
	"./a020-ngo-1.svg": 1691,
	"./a020-ngo-2.svg": 1692,
	"./a020-ngo-3.svg": 1693,
	"./a020-ngo-4.svg": 1694,
	"./a020-ngo-5.svg": 1695,
	"./a021-viewmore-en.jpg": 759,
	"./a021-viewmore-en.png": 1696,
	"./a021-viewmore-fsi.jpg": 760,
	"./a021-viewmore.jpg": 761,
	"./a021-viewmore.png": 1697,
	"./a022-market.svg": 1698,
	"./a023-01.png": 762,
	"./a023-02.png": 763,
	"./a023-03.png": 764,
	"./a023-04.png": 765,
	"./a023-05.png": 766,
	"./a023-06.png": 767,
	"./a023-1.png": 768,
	"./a023-2.png": 769,
	"./a023-3.png": 770,
	"./a023-4.png": 771,
	"./a023-example1.png": 772,
	"./a023-example2.png": 773,
	"./a023-example3.png": 774,
	"./a023-fsi1-short.png": 775,
	"./a023-fsi2-short.png": 776,
	"./a023-fsi3-short.png": 777,
	"./a023-fsi4-short.png": 778,
	"./a023-fsi5-short.png": 779,
	"./a023-short1.jpg": 275,
	"./a023-short2.jpg": 276,
	"./a023-short3.jpg": 277,
	"./a023-short4.jpg": 278,
	"./a023-short5.jpg": 279,
	"./a023-short6.jpg": 280,
	"./a023-startup1-en-short.png": 780,
	"./a023-startup1-en.png": 781,
	"./a023-startup1-short.png": 782,
	"./a023-startup1.png": 783,
	"./a023-startup2-en-short.png": 784,
	"./a023-startup2-en.png": 785,
	"./a023-startup2-short.png": 786,
	"./a023-startup2.png": 787,
	"./a023-startup3-en-short.png": 788,
	"./a023-startup3-en.png": 789,
	"./a023-startup3-short.png": 790,
	"./a023-startup3.png": 791,
	"./a023-startup4-en-short.png": 792,
	"./a023-startup4-en.png": 793,
	"./a023-startup4-short.png": 794,
	"./a023-startup4.png": 795,
	"./a023-startup5-en-short.png": 796,
	"./a023-startup5-en.png": 797,
	"./a023-startup5-short.png": 798,
	"./a023-startup5.png": 799,
	"./a024-1.gif": 1699,
	"./a024-1.svg": 1700,
	"./a024-10.svg": 1701,
	"./a024-11.svg": 1702,
	"./a024-12.svg": 1703,
	"./a024-2.gif": 1704,
	"./a024-2.svg": 1705,
	"./a024-3.svg": 1706,
	"./a024-4.svg": 1707,
	"./a024-5.svg": 1708,
	"./a024-6.svg": 1709,
	"./a024-7.svg": 1710,
	"./a024-8.svg": 1711,
	"./a024-9.svg": 1712,
	"./a024-startup-1.svg": 1713,
	"./a024-startup-2.svg": 1714,
	"./a024-startup-3.svg": 1715,
	"./a024-startup-4.svg": 1716,
	"./a024-startup-5.svg": 1717,
	"./a024-startup-6.svg": 1718,
	"./a026-example1-en.png": 1719,
	"./a026-example1.jpg": 800,
	"./a026-example2.jpg": 801,
	"./a026-example3.jpg": 802,
	"./a026-example4.jpg": 803,
	"./a026-example5.jpg": 804,
	"./a026-example6.jpg": 805,
	"./a026-example7.jpg": 806,
	"./a026-example8.png": 1720,
	"./a028-1.png": 807,
	"./a028-1.svg": 1721,
	"./a028-2.png": 808,
	"./a028-2.svg": 1722,
	"./a028-3.png": 809,
	"./a028-3.svg": 1723,
	"./a028-4.png": 810,
	"./a028-4.svg": 1724,
	"./a028-5.png": 811,
	"./a028-5.svg": 1725,
	"./a028-6.png": 812,
	"./a028-example1.jpg": 813,
	"./a028-example2.jpg": 814,
	"./a028-example3.jpg": 815,
	"./a033.png": 1726,
	"./a036-1.svg": 1727,
	"./a036-2.svg": 1728,
	"./a036-3.svg": 1729,
	"./a036-4.svg": 1730,
	"./a036-5.svg": 1731,
	"./a037-1.svg": 1732,
	"./a037-10.svg": 1733,
	"./a037-2.svg": 1734,
	"./a037-3.svg": 1735,
	"./a037-4.svg": 1736,
	"./a037-5.svg": 1737,
	"./a037-6.svg": 1738,
	"./a037-7.svg": 1739,
	"./a037-8.svg": 1740,
	"./a037-9.svg": 1741,
	"./a037-IDNumber-08.png": 1742,
	"./a037-a.jpg": 816,
	"./a037-address-02.png": 1743,
	"./a037-b.jpg": 817,
	"./a037-biometricData-10.png": 1744,
	"./a037-c.jpg": 818,
	"./a037-d.jpg": 819,
	"./a037-dateofBirth-05.png": 1745,
	"./a037-driverLicenseNumber-06.png": 1746,
	"./a037-e.jpg": 820,
	"./a037-emailAddress-04.png": 1747,
	"./a037-f.jpg": 821,
	"./a037-financialAccount-09.png": 1748,
	"./a037-g.jpg": 822,
	"./a037-h.jpg": 823,
	"./a037-i.jpg": 824,
	"./a037-j.jpg": 825,
	"./a037-k.jpg": 826,
	"./a037-l.jpg": 827,
	"./a037-m.jpg": 828,
	"./a037-n.jpg": 829,
	"./a037-name-01.png": 1749,
	"./a037-passportNumber-07.png": 1750,
	"./a037-phoneNumber-03.png": 1751,
	"./a037-student-1-en.png": 1752,
	"./a037-student-1-sc.png": 1753,
	"./a037-student-1.png": 1754,
	"./a037-student-2.png": 1755,
	"./a037-student-t3-1.svg": 1756,
	"./a037-student-t3-10.svg": 1757,
	"./a037-student-t3-2.svg": 1758,
	"./a037-student-t3-3.svg": 1759,
	"./a037-student-t3-4.svg": 1760,
	"./a037-student-t3-5.svg": 1761,
	"./a037-student-t3-6.svg": 1762,
	"./a037-student-t3-7.svg": 1763,
	"./a037-student-t3-8.svg": 1764,
	"./a037-student-t3-9.svg": 1765,
	"./a037-student-t3-s3-1.svg": 1766,
	"./a037-student-t3-s3-10.svg": 1767,
	"./a037-student-t3-s3-2.svg": 1768,
	"./a037-student-t3-s3-3.svg": 1769,
	"./a037-student-t3-s3-4.svg": 1770,
	"./a037-student-t3-s3-5.svg": 1771,
	"./a037-student-t3-s3-6.svg": 1772,
	"./a037-student-t3-s3-7.svg": 1773,
	"./a037-student-t3-s3-8.svg": 1774,
	"./a037-student-t3-s3-9.svg": 1775,
	"./a038-1.svg": 1776,
	"./a038-2.svg": 1777,
	"./a038-3.svg": 1778,
	"./a038-4.svg": 1779,
	"./a038-5.svg": 1780,
	"./a038-6.svg": 1781,
	"./a038-7.svg": 1782,
	"./a041-1.png": 1783,
	"./a041-2.png": 1784,
	"./a041-3.png": 1785,
	"./a041-4.png": 1786,
	"./a041-5.png": 1787,
	"./a041-fsi1-bottom.png": 1788,
	"./a041-fsi1-top.png": 1789,
	"./a041-fsi2-bottom.png": 1790,
	"./a041-fsi2-top.png": 1791,
	"./a041-fsi3-bottom.png": 1792,
	"./a041-fsi3-top.png": 1793,
	"./a041-fsi4-bottom.png": 1794,
	"./a041-fsi4-top.png": 1795,
	"./a041-fsi5-bottom.png": 1796,
	"./a041-fsi5-top.png": 1797,
	"./a044-1.png": 1798,
	"./a044-2.png": 1799,
	"./a044-3.png": 1800,
	"./a044-4.png": 1801,
	"./a044-5.png": 1802,
	"./a044-6.png": 1803,
	"./a046-1.png": 1804,
	"./a046-2.png": 1805,
	"./a046-3.png": 1806,
	"./a046-4.png": 1807,
	"./a046-5.png": 1808,
	"./a046-6.png": 1809,
	"./a047-icon1.png": 1810,
	"./a047-icon2.png": 1811,
	"./a047-icon3.png": 1812,
	"./a047-icon4.png": 1813,
	"./a047-icon5.png": 1814,
	"./a047-icon6.png": 1815,
	"./a047-icon7.png": 1816,
	"./a047-icon8.png": 1817,
	"./a047-vector-purple.png": 1818,
	"./a047-vector-red.png": 1819,
	"./a047-vector.png": 1820,
	"./aiSecurity.png": 1821,
	"./aiSecurityRealcase-en.jpg": 830,
	"./aiSecurityRealcase-mobile-en.jpg": 831,
	"./aiSecurityRealcase-mobile.jpg": 832,
	"./aiSecurityRealcase.jpg": 833,
	"./animation-arrow.gif": 101,
	"./animation-arrow10.gif": 1822,
	"./animation-arrow11.gif": 1823,
	"./animation-arrow12.gif": 1824,
	"./animation-arrow13.gif": 1825,
	"./animation-arrow2.gif": 1826,
	"./animation-arrow20.gif": 1827,
	"./animation-arrow26.gif": 1828,
	"./animation-arrow3.gif": 1829,
	"./animation-arrow4.gif": 1830,
	"./animation-arrow5.gif": 1831,
	"./animation-arrow6.gif": 1832,
	"./animation-arrow7.gif": 1833,
	"./animation-arrow8.gif": 1834,
	"./animation-arrow9.gif": 1835,
	"./animation-quiz.gif": 1836,
	"./animation004-1.png": 56,
	"./animation004-2.png": 1837,
	"./animation021-01.svg": 1838,
	"./animation021-02.svg": 1839,
	"./animation021-03.svg": 1840,
	"./animation021-04.svg": 1841,
	"./animation021-05.svg": 1842,
	"./animation021-06.svg": 1843,
	"./animation_password.gif": 1844,
	"./animation_password_en.gif": 1845,
	"./animation_point.gif": 4,
	"./arrow-left-long.png": 14,
	"./arrow-left.png": 138,
	"./arrow-right-long.png": 15,
	"./arrow-right.png": 139,
	"./arrow.png": 75,
	"./avater1.png": 1846,
	"./avater2.png": 1847,
	"./avater3.png": 1848,
	"./avater4.png": 1849,
	"./avater5.png": 1850,
	"./avater6.png": 55,
	"./avater7.png": 53,
	"./avater8.png": 1851,
	"./avater9.png": 1852,
	"./avaterStudent.svg": 1853,
	"./boss-right2.png": 1854,
	"./bp1.png": 1855,
	"./bp10.png": 1856,
	"./bp11.png": 1857,
	"./bp2.png": 1858,
	"./bp3.png": 1859,
	"./bp4.png": 1860,
	"./bp5.png": 1861,
	"./bp6.png": 1862,
	"./bp7.png": 1863,
	"./bp8.png": 1864,
	"./bp9.png": 1865,
	"./business-problem1-en.png": 1866,
	"./business-problem1-sc.png": 1867,
	"./business-problem1.png": 1868,
	"./business-problem2.gif": 1869,
	"./business-problem3.png": 1870,
	"./business-problem4-en.png": 1871,
	"./business-problem4.png": 1872,
	"./business-problem5-en.png": 1873,
	"./business-problem5-sc.png": 1874,
	"./business-problem5.png": 1875,
	"./c001-E-commerce-1.jpg": 834,
	"./c001-E-commerce-2.jpg": 835,
	"./c001-E-commerce-3.jpg": 836,
	"./c001-E-commerce-4.jpg": 837,
	"./c001-E-commerce-5.jpg": 838,
	"./c001-E-commerce-6.jpg": 839,
	"./c001-Picture1.jpg": 840,
	"./c001-Picture2.jpg": 841,
	"./c001-Picture3.jpg": 842,
	"./c001-fsi-1.jpg": 843,
	"./c001-fsi-2.jpg": 844,
	"./c001-fsi-3.jpg": 845,
	"./c001-fsi-4.jpg": 846,
	"./c001-general2024-1.png": 1876,
	"./c001-general2024-2.png": 1877,
	"./c001-general2024-3.png": 1878,
	"./c001-general2024-4.png": 1879,
	"./c001-general2024-5.png": 1880,
	"./c001-general2024-6.png": 1881,
	"./c001-general2024-7.png": 1882,
	"./c001-general2024-8.png": 1883,
	"./c001-ngo-1.jpg": 847,
	"./c001-ngo-2.jpg": 848,
	"./c001-ngo-3.jpg": 849,
	"./c001-ngo-4.jpg": 850,
	"./c001-ngo-5.jpg": 851,
	"./c001-student-1.jpg": 852,
	"./c001-student-2.jpg": 853,
	"./c001-student-3.jpg": 854,
	"./c001-student-4.jpg": 855,
	"./c001-student-5.jpg": 856,
	"./c001-student-6.jpg": 857,
	"./c001-student-7.jpg": 858,
	"./c001-student-8.jpg": 859,
	"./c002-1.png": 1884,
	"./c002-1.svg": 1885,
	"./c002-PPII-1.svg": 1886,
	"./c002-PPII-10.svg": 1887,
	"./c002-PPII-11.svg": 1888,
	"./c002-PPII-12.svg": 1889,
	"./c002-PPII-13.svg": 1890,
	"./c002-PPII-14.svg": 1891,
	"./c002-PPII-15.svg": 1892,
	"./c002-PPII-16.svg": 1893,
	"./c002-PPII-2.svg": 1894,
	"./c002-PPII-3.svg": 1895,
	"./c002-PPII-4.svg": 1896,
	"./c002-PPII-6.svg": 1897,
	"./c002-PPII-7.svg": 1898,
	"./c002-PPII-8.svg": 1899,
	"./c002-PPII-9.svg": 1900,
	"./c002-eCommerce.png": 1901,
	"./c002-example1.jpg": 860,
	"./c002-general2024-example1.jpg": 861,
	"./c002-pic.png": 1902,
	"./c002-whatsapp-01-en.png": 1903,
	"./c002-whatsapp-01.png": 1904,
	"./c002-whatsapp-02-en.png": 1905,
	"./c002-whatsapp-02.png": 1906,
	"./c003-man-left.png": 1907,
	"./c003-right-lady.png": 1908,
	"./c005-1.png": 1909,
	"./c005-10.png": 1910,
	"./c005-11.png": 1911,
	"./c005-12.png": 1912,
	"./c005-13.png": 1913,
	"./c005-2.png": 1914,
	"./c005-3.png": 1915,
	"./c005-4.png": 1916,
	"./c005-5.png": 1917,
	"./c005-6.png": 1918,
	"./c005-7.png": 1919,
	"./c005-8.png": 1920,
	"./c005-9.png": 1921,
	"./c005-arrow01.png": 422,
	"./c005-arrow02.png": 423,
	"./c005-whatsapp-01-en.png": 1922,
	"./c005-whatsapp-01.png": 1923,
	"./c005-whatsapp-02-en.png": 1924,
	"./c005-whatsapp-02.png": 1925,
	"./c005-whatsapp-03-en.png": 1926,
	"./c005-whatsapp-03.png": 1927,
	"./c006-1.jpg": 862,
	"./c006-2.jpg": 863,
	"./c006-3.jpg": 864,
	"./c006-4.jpg": 865,
	"./c006-5.gif": 1928,
	"./c006-5.jpg": 866,
	"./c006-6.gif": 1929,
	"./c006-6.jpg": 867,
	"./c006-a.jpg": 868,
	"./c006-b.jpg": 869,
	"./c006-b.png": 1930,
	"./c006-c.jpg": 870,
	"./c006-c.png": 1931,
	"./c006-d.jpg": 871,
	"./c007-1.jpg": 872,
	"./c007-bg.jpg": 873,
	"./c008-1.png": 1932,
	"./c008-2.png": 1933,
	"./c008-2.svg": 1934,
	"./c008-3.svg": 1935,
	"./c008-board.svg": 1936,
	"./c008-board1.svg": 1937,
	"./c010-1.png": 1938,
	"./c010-2.png": 1939,
	"./c010-3.png": 1940,
	"./c010-4.png": 1941,
	"./c013-1.png": 1942,
	"./c013-2.png": 1943,
	"./calendar.png": 424,
	"./can-do.png": 1944,
	"./can-do.svg": 1945,
	"./can-do1.png": 1946,
	"./can-not-do.png": 1947,
	"./ceritificate-background.png": 1948,
	"./cert/cert-E-commerce-HKIRC.jpg": 874,
	"./cert/cert-E-commerce-consumer.jpg": 875,
	"./cert/cert-E-commerce-cpttm.jpg": 281,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 876,
	"./cert/cert-customer-HKIRC.jpg": 877,
	"./cert/cert-customer-consumer.jpg": 878,
	"./cert/cert-customer-cpttm.jpg": 282,
	"./cert/cert-customer-hkgcsmeaa.jpg": 879,
	"./cert/cert-finance-HKIRC-sc.jpg": 880,
	"./cert/cert-finance-HKIRC.jpg": 881,
	"./cert/cert-finance-consumer-sc.jpg": 882,
	"./cert/cert-finance-consumer.jpg": 883,
	"./cert/cert-finance-cpttm-sc.jpg": 283,
	"./cert/cert-finance-cpttm.jpg": 284,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 884,
	"./cert/cert-finance-hkgcsmeaa.jpg": 885,
	"./cert/cert-fsi-HKIRC-sc.jpg": 886,
	"./cert/cert-fsi-HKIRC.jpg": 887,
	"./cert/cert-fsi-consumer-sc.jpg": 888,
	"./cert/cert-fsi-consumer.jpg": 889,
	"./cert/cert-fsi-cpttm-sc.jpg": 285,
	"./cert/cert-fsi-cpttm.jpg": 286,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 890,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 891,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 892,
	"./cert/cert-general-staff-HKIRC.jpg": 893,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 894,
	"./cert/cert-general-staff-a-HKIRC.jpg": 895,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 896,
	"./cert/cert-general-staff-a-consumer.jpg": 897,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 287,
	"./cert/cert-general-staff-a-cpttm.jpg": 288,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 898,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 899,
	"./cert/cert-general-staff-consumer-sc.jpg": 900,
	"./cert/cert-general-staff-consumer.jpg": 901,
	"./cert/cert-general-staff-cpttm-sc.jpg": 289,
	"./cert/cert-general-staff-cpttm.jpg": 290,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 902,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 903,
	"./cert/cert-general2024-HKIRC-sc.jpg": 904,
	"./cert/cert-general2024-HKIRC.jpg": 905,
	"./cert/cert-general2024-consumer-sc.jpg": 906,
	"./cert/cert-general2024-consumer.jpg": 907,
	"./cert/cert-general2024-cpttm-sc.jpg": 219,
	"./cert/cert-general2024-cpttm.jpg": 220,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 908,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 909,
	"./cert/cert-hr-HKIRC.jpg": 910,
	"./cert/cert-hr-consumer.jpg": 911,
	"./cert/cert-hr-cpttm.jpg": 291,
	"./cert/cert-hr-hkgcsmeaa.jpg": 912,
	"./cert/cert-it-HKIRC.jpg": 913,
	"./cert/cert-it-consumer.jpg": 914,
	"./cert/cert-it-cpttm.jpg": 292,
	"./cert/cert-it-hkgcsmeaa.jpg": 915,
	"./cert/cert-market-HKIRC.jpg": 916,
	"./cert/cert-market-consumer.jpg": 917,
	"./cert/cert-market-cpttm.jpg": 293,
	"./cert/cert-market-hkgcsmeaa.jpg": 918,
	"./cert/cert-ngo-HKIRC.jpg": 919,
	"./cert/cert-ngo-consumer.jpg": 920,
	"./cert/cert-ngo-cpttm.jpg": 294,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 921,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 922,
	"./cert/cert-senior-manager-HKIRC.jpg": 923,
	"./cert/cert-senior-manager-consumer-sc.jpg": 924,
	"./cert/cert-senior-manager-consumer.jpg": 925,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 295,
	"./cert/cert-senior-manager-cpttm.jpg": 296,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 926,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 927,
	"./cert/cert-startup-HKIRC.jpg": 928,
	"./cert/cert-startup-consumer.jpg": 929,
	"./cert/cert-startup-cpttm.jpg": 297,
	"./cert/cert-startup-hkgcsmeaa.jpg": 930,
	"./cert/cert-student-HKIRC-sc.jpg": 931,
	"./cert/cert-student-HKIRC.jpg": 932,
	"./cert/cert-student-consumer-sc.jpg": 933,
	"./cert/cert-student-consumer.jpg": 934,
	"./cert/cert-student-cpttm-sc.jpg": 298,
	"./cert/cert-student-cpttm.jpg": 299,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 935,
	"./cert/cert-student-hkgcsmeaa.jpg": 936,
	"./chat.gif": 1949,
	"./component003-left.png": 37,
	"./component003-right.png": 38,
	"./component003Boss-left.png": 1950,
	"./component003Boss-right.png": 1951,
	"./component003Lady-right.png": 1952,
	"./component003Man-right.png": 1953,
	"./component003Student-right.svg": 1954,
	"./contacting.png": 1955,
	"./conversation-left.png": 28,
	"./conversation-right.png": 26,
	"./conversation-right2.png": 1956,
	"./courseLanding-PPII.png": 1957,
	"./courseLanding-aiSecurity.png": 1958,
	"./courseLanding-dataLeakage.png": 1959,
	"./courseLanding-ransomware-mobile.png": 1960,
	"./courseLanding-ransomware.png": 1961,
	"./courseLanding-socialMedia.png": 1962,
	"./courseLanding-whatsApp.png": 1963,
	"./courses/Finance.png": 1964,
	"./courses/Finance2.png": 1965,
	"./courses/GeneralStaff_Background.svg": 1966,
	"./courses/HR.png": 1967,
	"./courses/HotTopic_Background.svg": 1968,
	"./courses/IndustrySector_Background.svg": 1969,
	"./courses/JobPosition_Background.svg": 1970,
	"./courses/Manufacturing.png": 1971,
	"./courses/Ransomeware.png": 1972,
	"./courses/Retails.png": 1973,
	"./courses/Senior.png": 1974,
	"./courses/course1.png": 1975,
	"./courses/course10.png": 1976,
	"./courses/course8.png": 1977,
	"./courses/gf-topic1.png": 1978,
	"./cover.png": 1979,
	"./cs-a009-1.svg": 1980,
	"./cs-a009-2.svg": 1981,
	"./cs-a009-3.svg": 1982,
	"./cs-a009-4.svg": 1983,
	"./cs-a009-5.svg": 1984,
	"./cs-a009-6.svg": 1985,
	"./cs-a018-1.svg": 1986,
	"./cs-a018-10.svg": 1987,
	"./cs-a018-11.svg": 1988,
	"./cs-a018-2.svg": 1989,
	"./cs-a018-3.svg": 1990,
	"./cs-a018-4.svg": 1991,
	"./cs-a018-5.svg": 1992,
	"./cs-a018-6.svg": 1993,
	"./cs-a018-7.svg": 1994,
	"./cs-a018-8.svg": 1995,
	"./cs-a018-9.svg": 1996,
	"./cs-c001-Picture1.png": 1997,
	"./cs-c001-Picture2.png": 1998,
	"./cs-c001-Picture3.png": 1999,
	"./cs-c001-Picture4.png": 2000,
	"./cs-c003-boss-right.svg": 2001,
	"./cs-c003-right.svg": 2002,
	"./cs-gif1.gif": 2003,
	"./cs-gif2.gif": 2004,
	"./cs-gif3.gif": 2005,
	"./cs-gif4.gif": 2006,
	"./cs-welcome.svg": 2007,
	"./cyber-phishing1.png": 2008,
	"./cyber-phishing2.png": 2009,
	"./cyber-phishing3.png": 2010,
	"./cyber-phishing4.png": 2011,
	"./cybersecurity2026/close_icon.png": 2012,
	"./cybersecurity2026/error_bg.png": 2013,
	"./cybersecurity2026/finger.gif": 33,
	"./cybersecurity2026/quiz/correct_icon.png": 425,
	"./cybersecurity2026/quiz/error_icon.png": 426,
	"./cybersecurity2026/quiz/m_quiz_bg.png": 2014,
	"./cybersecurity2026/quiz/m_quiz_bg_1.png": 2015,
	"./cybersecurity2026/quiz/m_review_top_bg.png": 2016,
	"./cybersecurity2026/quiz/no_pass_bg.png": 2017,
	"./cybersecurity2026/quiz/no_pass_word_bg.png": 2018,
	"./cybersecurity2026/quiz/pass_bg.png": 2019,
	"./cybersecurity2026/quiz/pass_word_bg.png": 2020,
	"./cybersecurity2026/quiz/quiz_bg.png": 2021,
	"./cybersecurity2026/quiz/quiz_bg_1.png": 2022,
	"./cybersecurity2026/quiz/review_bg.png": 2023,
	"./cybersecurity2026/quiz/review_top_bg.png": 2024,
	"./cybersecurity2026/quiz/smile.png": 427,
	"./cybersecurity2026/quiz/upset.png": 428,
	"./cybersecurity2026/quiz_bg.png": 2025,
	"./cybersecurity2026/right_bg.png": 2026,
	"./cybersecurity2026/topic1000/bg1.png": 2027,
	"./cybersecurity2026/topic1000/bg2.png": 2028,
	"./cybersecurity2026/topic1000/bg3.png": 2029,
	"./cybersecurity2026/topic1000/bg4.png": 2030,
	"./cybersecurity2026/topic1000/bg5.png": 2031,
	"./cybersecurity2026/topic1000/bg6.png": 2032,
	"./cybersecurity2026/topic1000/bg7.png": 2033,
	"./cybersecurity2026/topic1000/date_bg.png": 2034,
	"./cybersecurity2026/topic1000/factor/factor_bubble.png": 2035,
	"./cybersecurity2026/topic1000/factor/factor_item_5.png": 2036,
	"./cybersecurity2026/topic1000/factor/factor_left_bg.png": 2037,
	"./cybersecurity2026/topic1000/factor/img.png": 2038,
	"./cybersecurity2026/topic1000/factor/img_1.png": 2039,
	"./cybersecurity2026/topic1000/factor/img_2.png": 2040,
	"./cybersecurity2026/topic1000/factor/img_3.png": 2041,
	"./cybersecurity2026/topic1000/factor/img_4.png": 2042,
	"./cybersecurity2026/topic1000/last_img.png": 429,
	"./cybersecurity2026/topic1000/light.png": 194,
	"./cybersecurity2026/topic1000/link1.png": 430,
	"./cybersecurity2026/topic1000/multiple/item1.png": 2043,
	"./cybersecurity2026/topic1000/multiple/item2.png": 2044,
	"./cybersecurity2026/topic1000/multiple/item3.png": 2045,
	"./cybersecurity2026/topic1000/multiple/m_multiple_bg.png": 2046,
	"./cybersecurity2026/topic1000/multiple/multiple_bg.png": 2047,
	"./cybersecurity2026/topic1000/person.png": 431,
	"./cybersecurity2026/topic1000/process/img.png": 2048,
	"./cybersecurity2026/topic1000/process/img_1.png": 2049,
	"./cybersecurity2026/topic1000/process/img_2.png": 2050,
	"./cybersecurity2026/topic1000/process/img_3.png": 2051,
	"./cybersecurity2026/topic1000/process/m_section1-process-bg.png": 2052,
	"./cybersecurity2026/topic1000/q_right_bg.png": 432,
	"./cybersecurity2026/topic1000/quiz_bg.png": 2053,
	"./cybersecurity2026/topic1000/quiz_bg_mobile.png": 2054,
	"./cybersecurity2026/topic1000/s3_bubble_left.png": 2055,
	"./cybersecurity2026/topic1000/s3_bubble_right.png": 2056,
	"./cybersecurity2026/topic1000/s3_item1.png": 2057,
	"./cybersecurity2026/topic1000/section-process-bg1.png": 2058,
	"./cybersecurity2026/topic1000/section-process-bg3.png": 2059,
	"./cybersecurity2026/topic1000/section1-process-bg.png": 2060,
	"./cybersecurity2026/topic1000/section1_tool.png": 2061,
	"./cybersecurity2026/topic1000/section2_1.png": 433,
	"./cybersecurity2026/topic1000/section3_1.png": 2062,
	"./cybersecurity2026/topic1000/section3_2.png": 2063,
	"./cybersecurity2026/topic1000/section3_bg.png": 2064,
	"./cybersecurity2026/topic1000/section3_bubble.png": 2065,
	"./cybersecurity2026/topic1000/section4_bubble_left.png": 2066,
	"./cybersecurity2026/topic1000/section4_bubble_right.png": 2067,
	"./cybersecurity2026/topic1000/section4_ex.png": 2068,
	"./cybersecurity2026/topic1000/section5_1.png": 2069,
	"./cybersecurity2026/topic1000/tab_bg.png": 2070,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_1.png": 2071,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_1_m.png": 2072,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_2.png": 2073,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_2_m.png": 2074,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_3.png": 2075,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_3_m.png": 2076,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_4.png": 2077,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_4_m.png": 2078,
	"./cybersecurity2026/topic1000/tool_bubble.png": 2079,
	"./cybersecurity2026/topic1000/tools-bj-bottom.png": 434,
	"./cybersecurity2026/topic1000/tools-bj-top.png": 435,
	"./cybersecurity2026/topic1000/use/m_use_action_back_cz.png": 2080,
	"./cybersecurity2026/topic1000/use/m_use_action_back_hk.png": 2081,
	"./cybersecurity2026/topic1000/use/m_use_action_back_xw.png": 2082,
	"./cybersecurity2026/topic1000/use/m_use_action_back_zc.png": 2083,
	"./cybersecurity2026/topic1000/use/m_use_action_cz.png": 2084,
	"./cybersecurity2026/topic1000/use/m_use_action_hk.png": 2085,
	"./cybersecurity2026/topic1000/use/m_use_action_xw.png": 2086,
	"./cybersecurity2026/topic1000/use/m_use_action_zc.png": 2087,
	"./cybersecurity2026/topic1000/use/use_action_back_cz.png": 2088,
	"./cybersecurity2026/topic1000/use/use_action_back_hk.png": 2089,
	"./cybersecurity2026/topic1000/use/use_action_back_xw.png": 2090,
	"./cybersecurity2026/topic1000/use/use_action_back_zc.png": 2091,
	"./cybersecurity2026/topic1000/use/use_action_cz.png": 2092,
	"./cybersecurity2026/topic1000/use/use_action_hk.png": 2093,
	"./cybersecurity2026/topic1000/use/use_action_xw.png": 2094,
	"./cybersecurity2026/topic1000/use/use_action_zc.png": 2095,
	"./cybersecurity2026/topic1000/visit/header_bg.png": 2096,
	"./cybersecurity2026/topic1000/visit/icon1.png": 436,
	"./cybersecurity2026/topic1000/visit/icon2.png": 437,
	"./cybersecurity2026/topic1000/visit/icon3.png": 438,
	"./cybersecurity2026/topic1000/visit/img.png": 439,
	"./cybersecurity2026/topic1000/visit/img_1.png": 440,
	"./cybersecurity2026/topic1000/visit/img_2.png": 441,
	"./cybersecurity2026/topic1000/visit/img_3.png": 442,
	"./cybersecurity2026/topic1000/visit/img_4.png": 443,
	"./cybersecurity2026/topic1000/visit/img_5.png": 444,
	"./cybersecurity2026/topic1000/visit/img_6.png": 445,
	"./cybersecurity2026/topic1000/welcome_bg.png": 2097,
	"./cybersecurity2026/topic1000/welcome_bg_m.png": 2098,
	"./cybersecurity2026/topic1230pm/bg0.png": 2099,
	"./cybersecurity2026/topic1230pm/bg1.png": 2100,
	"./cybersecurity2026/topic1230pm/bg2.png": 2101,
	"./cybersecurity2026/topic1230pm/bg3.png": 2102,
	"./cybersecurity2026/topic1230pm/bg4.png": 2103,
	"./cybersecurity2026/topic1230pm/bg5.png": 2104,
	"./cybersecurity2026/topic1230pm/bg6.png": 2105,
	"./cybersecurity2026/topic1230pm/bg7.png": 2106,
	"./cybersecurity2026/topic1230pm/bg8.png": 2107,
	"./cybersecurity2026/topic1230pm/bg9.png": 2108,
	"./cybersecurity2026/topic1230pm/dialogue-left.png": 2109,
	"./cybersecurity2026/topic1230pm/dialogue-right.png": 2110,
	"./cybersecurity2026/topic1230pm/question.png": 2111,
	"./cybersecurity2026/topic1230pm/section0-img1.png": 446,
	"./cybersecurity2026/topic1230pm/section0-img2.png": 447,
	"./cybersecurity2026/topic1230pm/section1-bg1-h5.png": 2112,
	"./cybersecurity2026/topic1230pm/section1-bg1.png": 2113,
	"./cybersecurity2026/topic1230pm/section1-bg2-h5.png": 2114,
	"./cybersecurity2026/topic1230pm/section1-bg2.png": 2115,
	"./cybersecurity2026/topic1230pm/section1-bg3.png": 2116,
	"./cybersecurity2026/topic1230pm/section1-bg4.png": 2117,
	"./cybersecurity2026/topic1230pm/section1-img1.png": 2118,
	"./cybersecurity2026/topic1230pm/section1-img2.png": 2119,
	"./cybersecurity2026/topic1230pm/section1-item-1-h5.png": 2120,
	"./cybersecurity2026/topic1230pm/section1-item-1.png": 2121,
	"./cybersecurity2026/topic1230pm/section1-item-2-h5.png": 2122,
	"./cybersecurity2026/topic1230pm/section1-item-2.png": 2123,
	"./cybersecurity2026/topic1230pm/section1-item-3-h5.png": 2124,
	"./cybersecurity2026/topic1230pm/section1-item-3.png": 2125,
	"./cybersecurity2026/topic1230pm/section1-item-4-h5.png": 2126,
	"./cybersecurity2026/topic1230pm/section1-item-4.png": 2127,
	"./cybersecurity2026/topic1230pm/section2-bg.png": 2128,
	"./cybersecurity2026/topic1230pm/section2-bg1-h5.png": 2129,
	"./cybersecurity2026/topic1230pm/section2-bg1.png": 2130,
	"./cybersecurity2026/topic1230pm/section2-bg2-h5.png": 2131,
	"./cybersecurity2026/topic1230pm/section2-bg2.png": 2132,
	"./cybersecurity2026/topic1230pm/section2-bg3-h5.png": 2133,
	"./cybersecurity2026/topic1230pm/section2-bg3.png": 2134,
	"./cybersecurity2026/topic1230pm/section2-bg4-h5.png": 2135,
	"./cybersecurity2026/topic1230pm/section2-bg4.png": 2136,
	"./cybersecurity2026/topic1230pm/section2-bg5.png": 2137,
	"./cybersecurity2026/topic1230pm/section2-bg6.png": 2138,
	"./cybersecurity2026/topic1230pm/section2-guide-bar-h5.png": 2139,
	"./cybersecurity2026/topic1230pm/section2-guide-bar.png": 2140,
	"./cybersecurity2026/topic1230pm/section2-pic1.png": 448,
	"./cybersecurity2026/topic1230pm/section2-pic2.png": 449,
	"./cybersecurity2026/topic1230pm/section3-img1.png": 450,
	"./cybersecurity2026/topic1230pm/section3-img2.png": 451,
	"./cybersecurity2026/topic1230pm/section3-img3.png": 452,
	"./cybersecurity2026/topic1230pm/section3-num1.png": 453,
	"./cybersecurity2026/topic1230pm/section3-num2.png": 454,
	"./cybersecurity2026/topic1230pm/section3-num3.png": 455,
	"./cybersecurity2026/topic1230pm/section3-num4.png": 456,
	"./cybersecurity2026/topic1230pm/section3-num5.png": 457,
	"./cybersecurity2026/topic1230pm/section3-pic2.png": 458,
	"./cybersecurity2026/topic1230pm/section3-pic3.png": 2141,
	"./cybersecurity2026/topic1230pm/section3-pic4.png": 2142,
	"./cybersecurity2026/topic1230pm/section3-pic5.png": 2143,
	"./cybersecurity2026/topic1230pm/section3-pic6-h5.png": 2144,
	"./cybersecurity2026/topic1230pm/section3-pic6.png": 2145,
	"./cybersecurity2026/topic1230pm/section3-pic7.png": 2146,
	"./cybersecurity2026/topic1230pm/section3-pic8.png": 2147,
	"./cybersecurity2026/topic1230pm/section4-pic1.png": 2148,
	"./cybersecurity2026/topic1230pm/section4-pic2.png": 2149,
	"./cybersecurity2026/topic1230pm/section4-pic3.png": 459,
	"./cybersecurity2026/topic1230pm/section5-pic1-h5.png": 2150,
	"./cybersecurity2026/topic1230pm/section5-pic1.png": 2151,
	"./cybersecurity2026/topic1230pm/section5-pic2.png": 2152,
	"./cybersecurity2026/topic1230pm/section5-pic3.png": 2153,
	"./cybersecurity2026/topic1600/attentions/icon1.png": 460,
	"./cybersecurity2026/topic1600/attentions/icon2.png": 461,
	"./cybersecurity2026/topic1600/attentions/icon3.png": 462,
	"./cybersecurity2026/topic1600/attentions/icon4.png": 463,
	"./cybersecurity2026/topic1600/bg1.png": 2154,
	"./cybersecurity2026/topic1600/bg2.png": 2155,
	"./cybersecurity2026/topic1600/bg3.png": 2156,
	"./cybersecurity2026/topic1600/bg4.png": 2157,
	"./cybersecurity2026/topic1600/bg5.png": 2158,
	"./cybersecurity2026/topic1600/bg6.png": 2159,
	"./cybersecurity2026/topic1600/bg7.png": 2160,
	"./cybersecurity2026/topic1600/bg8.png": 2161,
	"./cybersecurity2026/topic1600/bg9.png": 2162,
	"./cybersecurity2026/topic1600/data-analysis.png": 464,
	"./cybersecurity2026/topic1600/guide_bg.png": 2163,
	"./cybersecurity2026/topic1600/guide_bg_top.png": 2164,
	"./cybersecurity2026/topic1600/link_1.png": 465,
	"./cybersecurity2026/topic1600/link_2.png": 466,
	"./cybersecurity2026/topic1600/link_3.png": 467,
	"./cybersecurity2026/topic1600/link_pic.png": 468,
	"./cybersecurity2026/topic1600/m_guide_bg_bottom.png": 2165,
	"./cybersecurity2026/topic1600/m_guide_bg_top.png": 2166,
	"./cybersecurity2026/topic1600/person.png": 469,
	"./cybersecurity2026/topic1600/quiz_bg.png": 2167,
	"./cybersecurity2026/topic1600/regression_bottom.png": 470,
	"./cybersecurity2026/topic1600/regression_top.png": 471,
	"./cybersecurity2026/topic1600/risk/img.png": 472,
	"./cybersecurity2026/topic1600/risk/img_1.png": 473,
	"./cybersecurity2026/topic1600/risk/img_2.png": 474,
	"./cybersecurity2026/topic1600/risk/img_3.png": 475,
	"./cybersecurity2026/topic1600/risk/img_4.png": 476,
	"./cybersecurity2026/topic1600/risk/img_5.png": 477,
	"./cybersecurity2026/topic1600/section1-bg-left.png": 2168,
	"./cybersecurity2026/topic1600/section1-bubble.png": 2169,
	"./cybersecurity2026/topic1600/section1_1.png": 478,
	"./cybersecurity2026/topic1600/section1_bubble.png": 2170,
	"./cybersecurity2026/topic1600/tools-bottom.png": 479,
	"./cybersecurity2026/topic1600/tools-top.png": 480,
	"./cybersecurity2026/topic1600/top-box-img.png": 481,
	"./cybersecurity2026/topic1600/trend-bubble.png": 2171,
	"./cybersecurity2026/topic1600/trend-top.png": 482,
	"./cybersecurity2026/topic1600/use/m_use_action_back1.png": 2172,
	"./cybersecurity2026/topic1600/use/m_use_action_back2.png": 2173,
	"./cybersecurity2026/topic1600/use/m_use_action_back3.png": 2174,
	"./cybersecurity2026/topic1600/use/m_use_action_back4.png": 2175,
	"./cybersecurity2026/topic1600/use/use_action_back1.png": 2176,
	"./cybersecurity2026/topic1600/use/use_action_back2.png": 2177,
	"./cybersecurity2026/topic1600/use/use_action_back3.png": 2178,
	"./cybersecurity2026/topic1600/use/use_action_back4.png": 2179,
	"./cybersecurity2026/topic900/background1.png": 2180,
	"./cybersecurity2026/topic900/background2.png": 2181,
	"./cybersecurity2026/topic900/background3.png": 2182,
	"./cybersecurity2026/topic900/background4.png": 2183,
	"./cybersecurity2026/topic900/bg-h5.png": 2184,
	"./cybersecurity2026/topic900/bubble-orange.png": 2185,
	"./cybersecurity2026/topic900/chatBg-h5.png": 2186,
	"./cybersecurity2026/topic900/chatBg.png": 2187,
	"./cybersecurity2026/topic900/section1-bg.png": 2188,
	"./cybersecurity2026/topic900/section1-header-Alert.png": 483,
	"./cybersecurity2026/topic900/section1-header-Edit.png": 484,
	"./cybersecurity2026/topic900/section1-header-Eye-off.png": 485,
	"./cybersecurity2026/topic900/section1-header-Hard-drive.png": 486,
	"./cybersecurity2026/topic900/section1-header-btn.png": 2189,
	"./cybersecurity2026/topic900/section1-header.png": 2190,
	"./cybersecurity2026/topic900/section1-img3.png": 2191,
	"./cybersecurity2026/topic900/section1-img4.png": 487,
	"./cybersecurity2026/topic900/section3-bg.png": 2192,
	"./cybersecurity2026/topic900/section3-icon1.png": 488,
	"./cybersecurity2026/topic900/section3-icon2.png": 489,
	"./cybersecurity2026/topic900/section3-img2.png": 490,
	"./cybersecurity2026/topic900/section4-bg.png": 2193,
	"./cybersecurity2026/topic900/section4-bg2-h5.png": 2194,
	"./cybersecurity2026/topic900/section4-bg2.png": 2195,
	"./cybersecurity2026/topic900/section4-pic1.png": 2196,
	"./cybersecurity2026/topic900/talk-down.png": 2197,
	"./cybersecurity2026/topic900/talk-up.png": 2198,
	"./cybersecurity2026/topic900/topic900_bg1.png": 491,
	"./cybersecurity2026/topic900/topic900_bg2.png": 492,
	"./cybersecurity2026/welcome/bubble.png": 2199,
	"./cybersecurity2026/welcome/folder.png": 2200,
	"./cybersecurity2026/welcome/four.png": 493,
	"./cybersecurity2026/welcome/highway.png": 2201,
	"./cybersecurity2026/welcome/line.png": 494,
	"./cybersecurity2026/welcome/m_highway.png": 2202,
	"./cybersecurity2026/welcome/m_welcome_bg.png": 2203,
	"./cybersecurity2026/welcome/person.png": 2204,
	"./cybersecurity2026/welcome/record.png": 2205,
	"./cybersecurity2026/welcome/three.png": 495,
	"./cybersecurity2026/welcome/triangle.png": 496,
	"./cybersecurity2026/welcome/two.png": 497,
	"./cybersecurity2026/welcome/welcome_bg.png": 2206,
	"./dataLeakage.png": 2207,
	"./dataLeakageRealcase-en.jpg": 937,
	"./dataLeakageRealcase-mobile-en.jpg": 938,
	"./dataLeakageRealcase-mobile.jpg": 939,
	"./dataLeakageRealcase.jpg": 940,
	"./desk-clean-icon1.png": 2208,
	"./desk-clean-icon2.png": 2209,
	"./desk-clean-icon3.png": 2210,
	"./desk-clean-icon4.png": 2211,
	"./desk-clean-img1.png": 2212,
	"./desk-clean-img2.png": 2213,
	"./desk-clean-img3.png": 2214,
	"./desk-clean-img4.png": 2215,
	"./desk-clean1.png": 2216,
	"./desk-clean2.png": 2217,
	"./desk-clean3.png": 2218,
	"./desk-clean4.png": 2219,
	"./desk-clean5.png": 2220,
	"./education/close_icon.png": 195,
	"./education/cybersecurity/arrow-right-circle.png": 498,
	"./education/cybersecurity/bg-light.png": 2221,
	"./education/cybersecurity/bg1.png": 2222,
	"./education/cybersecurity/bg2.png": 2223,
	"./education/cybersecurity/bg3.png": 2224,
	"./education/cybersecurity/bg4.png": 2225,
	"./education/cybersecurity/bg5.png": 2226,
	"./education/cybersecurity/bg6.png": 2227,
	"./education/cybersecurity/bg7.png": 2228,
	"./education/cybersecurity/chat-bg-h5.png": 2229,
	"./education/cybersecurity/chat-bg-pc.png": 2230,
	"./education/cybersecurity/chatBg.png": 2231,
	"./education/cybersecurity/h5-bg/case-study-center.png": 2232,
	"./education/cybersecurity/h5-bg/case-study-left.png": 2233,
	"./education/cybersecurity/h5-bg/case-study-right.png": 2234,
	"./education/cybersecurity/h5-bg/case-study-tips.png": 2235,
	"./education/cybersecurity/h5-bg/h5-bg1.png": 2236,
	"./education/cybersecurity/h5-bg/h5-bg2.png": 2237,
	"./education/cybersecurity/h5-bg/h5-bg3.png": 2238,
	"./education/cybersecurity/h5-bg/h5-bg4.png": 2239,
	"./education/cybersecurity/h5-bg/h5-bg5.png": 2240,
	"./education/cybersecurity/h5-bg/h5-bg6.png": 2241,
	"./education/cybersecurity/h5-bg/h5-bg7.png": 2242,
	"./education/cybersecurity/h5-bg/h5-bg8.png": 2243,
	"./education/cybersecurity/h5-bg/h5-pic-bg1.png": 2244,
	"./education/cybersecurity/h5-bg/process-bg.png": 2245,
	"./education/cybersecurity/h5-bg/section-process-1.png": 2246,
	"./education/cybersecurity/h5-bg/section-process-2.png": 2247,
	"./education/cybersecurity/h5-bg/section-process-3.png": 2248,
	"./education/cybersecurity/h5-bg/section-process-4.png": 2249,
	"./education/cybersecurity/icon-award.png": 499,
	"./education/cybersecurity/icon-book-open.png": 500,
	"./education/cybersecurity/icon-cast.png": 501,
	"./education/cybersecurity/icon-chevrons up.png": 502,
	"./education/cybersecurity/icon-clock.png": 503,
	"./education/cybersecurity/icon-command.png": 504,
	"./education/cybersecurity/message-bg.png": 2250,
	"./education/cybersecurity/message-bg.svg": 2251,
	"./education/cybersecurity/num-01.svg": 505,
	"./education/cybersecurity/num-02.svg": 506,
	"./education/cybersecurity/num-03.svg": 507,
	"./education/cybersecurity/num-04.svg": 508,
	"./education/cybersecurity/num-05.svg": 509,
	"./education/cybersecurity/num-icon-bg.png": 510,
	"./education/cybersecurity/num-icon1.svg": 511,
	"./education/cybersecurity/num-icon2.svg": 512,
	"./education/cybersecurity/num-icon3.svg": 513,
	"./education/cybersecurity/num-icon4.svg": 514,
	"./education/cybersecurity/num-icon5.svg": 515,
	"./education/cybersecurity/plan-bg.svg": 2252,
	"./education/cybersecurity/plan-pic-bg-h5.png": 2253,
	"./education/cybersecurity/plan-pic.png": 516,
	"./education/cybersecurity/question-bg.png": 2254,
	"./education/cybersecurity/section-process-bg1.png": 2255,
	"./education/cybersecurity/section-process-bg2.png": 2256,
	"./education/cybersecurity/section-process-bg3.png": 2257,
	"./education/cybersecurity/section-process-bg4.png": 2258,
	"./education/cybersecurity/section0-bg1.png": 517,
	"./education/cybersecurity/section0-bg2.png": 518,
	"./education/cybersecurity/section0-bg3.png": 2259,
	"./education/cybersecurity/section1-bg-h5.png": 2260,
	"./education/cybersecurity/section1-bg1.png": 519,
	"./education/cybersecurity/section1-bg2.svg": 2261,
	"./education/cybersecurity/section1-bg3-h5.png": 2262,
	"./education/cybersecurity/section1-bg3.svg": 2263,
	"./education/cybersecurity/section1-bg4.svg": 2264,
	"./education/cybersecurity/section1-measure1.svg": 2265,
	"./education/cybersecurity/section1-measure2.svg": 2266,
	"./education/cybersecurity/section1-measure3.svg": 2267,
	"./education/cybersecurity/section1-process-bg.png": 2268,
	"./education/cybersecurity/section1-process-bg1.png": 520,
	"./education/cybersecurity/section1-process-bg2.png": 521,
	"./education/cybersecurity/union.png": 2269,
	"./education/error_bg.png": 2270,
	"./education/ot/background-left.png": 2271,
	"./education/ot/bubble_bg.png": 2272,
	"./education/ot/guide_bg.png": 2273,
	"./education/ot/guide_bg_top.png": 2274,
	"./education/ot/guide_bg_y.png": 2275,
	"./education/ot/h5_guide_bg_top.png": 2276,
	"./education/ot/header-bg.png": 2277,
	"./education/ot/icon/icon1.png": 522,
	"./education/ot/icon/icon2.png": 523,
	"./education/ot/icon/icon3.png": 524,
	"./education/ot/icon/icon4.png": 525,
	"./education/ot/icon/icon5.png": 526,
	"./education/ot/icon/icon6.png": 527,
	"./education/ot/m_background-left.png": 2278,
	"./education/ot/ot_quiz_bg.png": 2279,
	"./education/ot/person.png": 528,
	"./education/ot/picture/img1.png": 529,
	"./education/ot/picture/img2.png": 530,
	"./education/ot/picture/img3.png": 531,
	"./education/ot/picture/img4.png": 532,
	"./education/ot/picture/img5.png": 533,
	"./education/ot/picture/img6.png": 534,
	"./education/ot/section0_bg.png": 2280,
	"./education/ot/section1_bg.png": 2281,
	"./education/ot/section2_bg.png": 2282,
	"./education/ot/section2_bg_1.png": 2283,
	"./education/ot/section2_bg_2.png": 2284,
	"./education/ot/tools-bj-bottom.png": 2285,
	"./education/ot/tools-bj-top.png": 2286,
	"./education/ot/welcome_bg_bubble.png": 2287,
	"./education/ptm/ai-bg.png": 2288,
	"./education/ptm/ai_left_bg.png": 535,
	"./education/ptm/ai_right_bg.png": 536,
	"./education/ptm/bubble/bubble1.png": 2289,
	"./education/ptm/bubble/bubble3.png": 2290,
	"./education/ptm/bubble/bubble4.png": 2291,
	"./education/ptm/bubble/bubble6.png": 2292,
	"./education/ptm/bubble/m_bubble1.png": 2293,
	"./education/ptm/bubble/m_bubble3.png": 2294,
	"./education/ptm/bubble/m_bubble4.png": 2295,
	"./education/ptm/bubble/m_bubble6.png": 2296,
	"./education/ptm/bubble_bg.png": 2297,
	"./education/ptm/factor/factor_bubble.png": 2298,
	"./education/ptm/factor/factor_item_1.png": 2299,
	"./education/ptm/factor/factor_item_2.png": 2300,
	"./education/ptm/factor/factor_item_3.png": 2301,
	"./education/ptm/factor/factor_item_4.png": 2302,
	"./education/ptm/factor/m_factor_item_1.png": 2303,
	"./education/ptm/factor/m_factor_item_2.png": 2304,
	"./education/ptm/factor/m_factor_item_3.png": 2305,
	"./education/ptm/factor/m_factor_item_4.png": 2306,
	"./education/ptm/factor_left_bg.png": 2307,
	"./education/ptm/factor_right_bg.png": 537,
	"./education/ptm/light.png": 196,
	"./education/ptm/m_ai_bg.png": 2308,
	"./education/ptm/m_bubble_bg.png": 2309,
	"./education/ptm/m_ptm_bg_2.png": 2310,
	"./education/ptm/m_welcome_bg_bubble.png": 2311,
	"./education/ptm/person.png": 538,
	"./education/ptm/practice_left_bg.png": 539,
	"./education/ptm/practice_right_bg.png": 540,
	"./education/ptm/practice_top_bg.png": 541,
	"./education/ptm/ptm_bg_1.png": 2312,
	"./education/ptm/ptm_bg_2.png": 2313,
	"./education/ptm/ptm_quiz_bg.png": 2314,
	"./education/ptm/q_right_bg.png": 542,
	"./education/ptm/use/m_use_action_back_cz.png": 2315,
	"./education/ptm/use/m_use_action_back_hk.png": 2316,
	"./education/ptm/use/m_use_action_back_xw.png": 2317,
	"./education/ptm/use/m_use_action_back_zc.png": 2318,
	"./education/ptm/use/m_use_action_cz.png": 2319,
	"./education/ptm/use/m_use_action_hk.png": 2320,
	"./education/ptm/use/m_use_action_xw.png": 2321,
	"./education/ptm/use/m_use_action_zc.png": 2322,
	"./education/ptm/use/use_action_back_cz.png": 2323,
	"./education/ptm/use/use_action_back_hk.png": 2324,
	"./education/ptm/use/use_action_back_xw.png": 2325,
	"./education/ptm/use/use_action_back_zc.png": 2326,
	"./education/ptm/use/use_action_cz.png": 2327,
	"./education/ptm/use/use_action_hk.png": 2328,
	"./education/ptm/use/use_action_xw.png": 2329,
	"./education/ptm/use/use_action_zc.png": 2330,
	"./education/ptm/welcome_bg.png": 2331,
	"./education/ptm/welcome_bg_bottom.png": 2332,
	"./education/ptm/welcome_bg_bubble.png": 2333,
	"./education/quiz/again_icon.png": 197,
	"./education/quiz/answer_left.png": 198,
	"./education/quiz/correct_icon.png": 543,
	"./education/quiz/downward_icon.png": 199,
	"./education/quiz/error_icon.png": 544,
	"./education/quiz/m_quiz_bg.png": 2334,
	"./education/quiz/m_quiz_bg_1.png": 2335,
	"./education/quiz/m_review_top_bg.png": 2336,
	"./education/quiz/no_pass_bg.png": 2337,
	"./education/quiz/no_pass_person.png": 200,
	"./education/quiz/no_pass_word_bg.png": 2338,
	"./education/quiz/pass_bg.png": 2339,
	"./education/quiz/pass_download.png": 201,
	"./education/quiz/pass_person.png": 202,
	"./education/quiz/pass_word_bg.png": 2340,
	"./education/quiz/quiz_bg.png": 2341,
	"./education/quiz/quiz_bg_1.png": 2342,
	"./education/quiz/review_bg.png": 2343,
	"./education/quiz/review_top_bg.png": 2344,
	"./education/quiz/smile.png": 545,
	"./education/quiz/upset.png": 546,
	"./education/quiz_bg.png": 2345,
	"./education/quiz_mask.png": 2346,
	"./education/right_bg.png": 2347,
	"./education/topic1000/Interacting1.png": 547,
	"./education/topic1000/Interacting2.png": 548,
	"./education/topic1000/arrow.svg": 2348,
	"./education/topic1000/bg1.png": 2349,
	"./education/topic1000/bg2.png": 2350,
	"./education/topic1000/bg3.png": 2351,
	"./education/topic1000/bg4.png": 2352,
	"./education/topic1000/bubble/bubble1.png": 2353,
	"./education/topic1000/bubble/bubble3.png": 2354,
	"./education/topic1000/bubble/bubble4.png": 2355,
	"./education/topic1000/bubble/bubble6.png": 2356,
	"./education/topic1000/case-study-h5.png": 2357,
	"./education/topic1000/h5-bg/collapse-bg.png": 2358,
	"./education/topic1000/h5-bg/h5-section2-bg1.png": 2359,
	"./education/topic1000/h5-bg/h5-section2-bg2.png": 2360,
	"./education/topic1000/h5-bg/h5-section2-bg3.png": 2361,
	"./education/topic1000/h5-bg/h5-section2-bg4.png": 2362,
	"./education/topic1000/link1-1.png": 549,
	"./education/topic1000/link1.png": 550,
	"./education/topic1000/link2.png": 551,
	"./education/topic1000/link3.png": 552,
	"./education/topic1000/panelData1.png": 553,
	"./education/topic1000/panelData2.png": 554,
	"./education/topic1000/panelData3.png": 555,
	"./education/topic1000/panelData4.jpg": 235,
	"./education/topic1000/panelData5.png": 556,
	"./education/topic1000/panelData6.jpg": 236,
	"./education/topic1000/phishing/bg.svg": 2363,
	"./education/topic1000/phishing/bubble_bg.svg": 557,
	"./education/topic1000/phishing/chatBg.png": 2364,
	"./education/topic1000/phishing/chatBg2.png": 2365,
	"./education/topic1000/phishing/icon1.svg": 558,
	"./education/topic1000/phishing/icon2.svg": 559,
	"./education/topic1000/phishing/icon3.svg": 560,
	"./education/topic1000/phishing/icon4.svg": 561,
	"./education/topic1000/phishing/icon5.svg": 562,
	"./education/topic1000/phishing/icon6.svg": 563,
	"./education/topic1000/phishing/pic1.svg": 2366,
	"./education/topic1000/phishing/questionBg.png": 2367,
	"./education/topic1000/phishing/tab1.svg": 2368,
	"./education/topic1000/phishing/tab2.svg": 2369,
	"./education/topic1000/phishing/title_bg.svg": 2370,
	"./education/topic1000/seciton3_icon.svg": 2371,
	"./education/topic1000/section1_footer_bg.png": 564,
	"./education/topic1000/section1_tool.png": 2372,
	"./education/topic1000/section1_tool1.png": 2373,
	"./education/topic1000/section1_tool_bubble.svg": 2374,
	"./education/topic1000/section3-bg-left.png": 2375,
	"./education/topic1000/section3_bg2.svg": 565,
	"./education/topic1000/section3_bg3.png": 566,
	"./education/topic1000/section3_bg4.png": 2376,
	"./education/topic1000/section3_bg5.png": 2377,
	"./education/topic1000/step-h5-bg.png": 2378,
	"./education/topic1000/tool-pic/tool-item-h5-bg1.png": 2379,
	"./education/topic1000/tool-pic/tool-item-h5-bg2.png": 2380,
	"./education/topic1000/tool-pic/tool-item-h5-bg3.png": 2381,
	"./education/topic1000/tool-pic/tool-item-h5-bg4.png": 2382,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg1.png": 2383,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg2.png": 2384,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg3.png": 2385,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg4.png": 2386,
	"./education/topic1000/tool-pic/tool_bubble.png": 2387,
	"./education/topic1000/tool-pic/tool_bubble_blue.png": 2388,
	"./education/topic1000/tool-pic/tool_item_1.png": 2389,
	"./education/topic1000/tool-pic/tool_item_2.png": 2390,
	"./education/topic1000/tool-pic/tool_item_3.png": 2391,
	"./education/topic1000/tool-pic/tool_item_4.png": 2392,
	"./education/topic1000/tool-pic/tool_item_blue1.png": 2393,
	"./education/topic1000/tool-pic/tool_item_blue2.png": 2394,
	"./education/topic1000/tool-pic/tool_item_blue3.png": 2395,
	"./education/topic1000/tool-pic/tool_item_blue4.png": 2396,
	"./education/topic900/bg-light.png": 2397,
	"./education/topic900/bg-orange.png": 2398,
	"./education/topic900/bg-priority.png": 2399,
	"./education/topic900/bg-white.png": 2400,
	"./education/topic900/bg1.png": 2401,
	"./education/topic900/bg2.png": 2402,
	"./education/topic900/bg3.png": 2403,
	"./education/topic900/bg4.png": 2404,
	"./education/topic900/chatBg.png": 2405,
	"./education/topic900/cyber-policy-bg.png": 2406,
	"./education/topic900/h5-bg/h5-section1-bg1.png": 2407,
	"./education/topic900/h5-bg/h5-section1-bg2.png": 2408,
	"./education/topic900/h5-bg/h5-section1-bg3.png": 2409,
	"./education/topic900/h5-bg/h5-section1-bg4.png": 2410,
	"./education/topic900/h5-bg/h5-section1-bg5.png": 2411,
	"./education/topic900/h5-bg/h5-section1-bg6.png": 2412,
	"./education/topic900/h5-bg/h5-section1-pic1.png": 2413,
	"./education/topic900/h5-bg/h5-section1-step.png": 2414,
	"./education/topic900/h5-bg/h5-section1-tip1.png": 2415,
	"./education/topic900/ot_quiz_bg.png": 2416,
	"./education/topic900/person.svg": 567,
	"./education/topic900/priority.png": 2417,
	"./education/topic900/priority_icon1.png": 203,
	"./education/topic900/priority_icon2.png": 204,
	"./education/topic900/priority_icon3.svg": 205,
	"./education/topic900/right-circle.png": 247,
	"./education/topic900/section1_1.png": 206,
	"./education/topic900/section1_2.png": 2418,
	"./education/topic900/section2_1.svg": 568,
	"./education/topic900/section2_2.png": 2419,
	"./education/topic900/section2_3.svg": 2420,
	"./education/topic900/section3_bg.svg": 2421,
	"./education/topic900/step.png": 2422,
	"./education/topic900/step1.png": 2423,
	"./education/topic900/step1.svg": 2424,
	"./education/topic900/step11.png": 569,
	"./education/topic900/step2.png": 2425,
	"./education/topic900/step2.svg": 2426,
	"./education/topic900/step22.png": 570,
	"./education/topic900/step3.png": 571,
	"./education/topic900/step3.svg": 2427,
	"./education/topic900/step4.png": 572,
	"./education/topic900/topic900_bg1.png": 573,
	"./education/topic900/topic900_bg2.png": 574,
	"./education/topic900/topic900_tip.svg": 2428,
	"./education/welcome/five.png": 575,
	"./education/welcome/folder.png": 2429,
	"./education/welcome/four.png": 576,
	"./education/welcome/highway.png": 2430,
	"./education/welcome/line.png": 577,
	"./education/welcome/m_five.png": 578,
	"./education/welcome/m_four.png": 579,
	"./education/welcome/m_highway.png": 2431,
	"./education/welcome/m_two.png": 580,
	"./education/welcome/m_welcome_bg.png": 2432,
	"./education/welcome/one.png": 581,
	"./education/welcome/person.png": 2433,
	"./education/welcome/record.png": 2434,
	"./education/welcome/three.png": 582,
	"./education/welcome/two.png": 583,
	"./education/welcome/vase.png": 2435,
	"./education/welcome/welcome_bg.png": 2436,
	"./equal-highlight.png": 584,
	"./equal.png": 585,
	"./filterArrow.svg": 586,
	"./finance-gif1.gif": 2437,
	"./finance-gif2.gif": 2438,
	"./finance-gif3.gif": 2439,
	"./finance-gif4.gif": 2440,
	"./finance-topic1.png": 2441,
	"./finance-topic2.png": 2442,
	"./finance-topic3.png": 2443,
	"./finance-topic4.png": 2444,
	"./flame-training.gif": 2445,
	"./fonts/02b3f97a-406d-43cb-885c-ba5233577cad.woff2": 2446,
	"./fonts/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2": 2447,
	"./fonts/08edde9d-c27b-4731-a27f-d6cd9b01cd06.woff": 2448,
	"./fonts/14d824a2-2a5c-4692-8e30-74f6e177b675.ttf": 2449,
	"./fonts/2025/1635950212302373.otf": 2450,
	"./fonts/2025/SourceHanSansCN-Bold.otf": 2451,
	"./fonts/2025/SourceHanSansCN-Bold.ttf": 2452,
	"./fonts/2025/SourceHanSansCN-ExtraLight.ttf": 2453,
	"./fonts/2025/SourceHanSansCN-Heavy.ttf": 2454,
	"./fonts/2025/SourceHanSansCN-Medium.otf": 2455,
	"./fonts/2025/SourceHanSansCN-Normal.otf": 2456,
	"./fonts/2025/SourceHanSansCN-Regular.otf": 2457,
	"./fonts/2025/SourceHanSansCN-Regular.ttf": 2458,
	"./fonts/22c6282d-e7aa-406b-89dc-5176916a9c44.ttf": 2459,
	"./fonts/240c57a0-fdce-440d-9ce3-85e0cb56f470.woff2": 2460,
	"./fonts/2a34f1f8-d701-4949-b12d-133c1c2636eb.woff": 2461,
	"./fonts/418e7417-47f3-40a1-8817-519a566f9d82.eot": 2462,
	"./fonts/4c21ab66-1566-4a85-b310-fbc649985f88.eot": 2463,
	"./fonts/4cc8f5da-4e24-4929-8efb-866ffcb1fe7e.eot": 2464,
	"./fonts/522972a6-5867-47ae-82fc-a7cf9bd5d4d4.eot": 2465,
	"./fonts/556d95c6-2352-4272-9422-83d53f66cfa3.ttf": 2466,
	"./fonts/5640036d-d549-4f16-b31e-87da78d9e832.eot": 2467,
	"./fonts/7802e576-2ffa-4f22-a409-534355fbea79.woff": 2468,
	"./fonts/7b415a05-784a-4a4c-8c94-67e9288312f5.woff": 2469,
	"./fonts/7d63ccf8-e0ae-4dee-ad4d-bbc798aa5803.woff2": 2470,
	"./fonts/800da3b0-675f-465f-892d-d76cecbdd5b1.woff2": 2471,
	"./fonts/8f4a1705-214a-4dd0-80b8-72252c37e688.ttf": 2472,
	"./fonts/922917a9-4ca8-4c0b-b1bb-417b6ff0210e.ttf": 2473,
	"./fonts/93ce67e5-64e3-4a99-99a3-545f20c5beec.woff2": 2474,
	"./fonts/96b3a113-3e18-46f9-b6e3-5bdee7288b20.woff": 2475,
	"./fonts/b2c1327f-ab3d-4230-93d7-eee8596e1498.woff": 2476,
	"./fonts/cad33bbd-bbf2-423b-98c5-51136c054e14.woff": 2477,
	"./fonts/cb0d1e8a-e111-4dbf-82c2-e948aba954c0.eot": 2478,
	"./fonts/da266c3a-a094-4adc-a81e-12f73609ba16.eot": 2479,
	"./fonts/f07c25ed-2d61-4e44-99ab-a0bc3ec67662.ttf": 2480,
	"./fonts/f9c5199e-a996-4c08-9042-1eb845bb7495.woff2": 2481,
	"./fonts/fdf10d5e-4ce0-45e5-a6c1-5eaff6cb1c11.ttf": 2482,
	"./fsi1.gif": 2483,
	"./fsi2.gif": 2484,
	"./fsi3.gif": 2485,
	"./fsi4.gif": 2486,
	"./fsiRealCase1-en.jpg": 941,
	"./fsiRealCase1-mobile-en.jpg": 942,
	"./fsiRealCase1-mobile-sc.jpg": 943,
	"./fsiRealCase1-mobile.jpg": 944,
	"./fsiRealCase1-sc.jpg": 945,
	"./fsiRealCase1.jpg": 946,
	"./fsiRealCase2-en-mobile.jpg": 947,
	"./fsiRealCase2-en.jpg": 948,
	"./fsiRealCase2-mobile-sc.jpg": 949,
	"./fsiRealCase2-mobile.jpg": 950,
	"./fsiRealCase2-sc.jpg": 951,
	"./fsiRealCase2.jpg": 952,
	"./general2024-1.gif": 2487,
	"./general2024-2.gif": 2488,
	"./general2024-3.gif": 2489,
	"./general2024-4.gif": 2490,
	"./general2024RealCase1-en-mobile.jpg": 953,
	"./general2024RealCase1-en.jpg": 954,
	"./general2024RealCase1-mobile-sc.jpg": 955,
	"./general2024RealCase1-mobile.jpg": 956,
	"./general2024RealCase1-sc.jpg": 957,
	"./general2024RealCase1.jpg": 958,
	"./globe.png": 587,
	"./hacker-using-laptop.gif": 2491,
	"./hacker1-en.png": 2492,
	"./hacker1.png": 2493,
	"./hacker2-en.png": 2494,
	"./hacker2.png": 2495,
	"./hacker3-en.png": 2496,
	"./hacker3.png": 2497,
	"./happy-emoji.png": 140,
	"./homelandingbg.png": 2498,
	"./icon-business.png": 588,
	"./icon-certificate.png": 589,
	"./icon-employee.png": 590,
	"./icon-training.png": 591,
	"./icon-vector1.png": 2499,
	"./icon-vector2.png": 2500,
	"./icon-vector3.png": 2501,
	"./icon-vector4.png": 2502,
	"./icon1.png": 2503,
	"./icon10.png": 2504,
	"./icon11.png": 2505,
	"./icon12.png": 2506,
	"./icon2.png": 2507,
	"./icon3.png": 2508,
	"./icon4.png": 2509,
	"./icon5.png": 2510,
	"./icon6.png": 2511,
	"./icon7.png": 2512,
	"./icon8.png": 2513,
	"./icon9.png": 2514,
	"./info-forgot-password-in.gif": 2515,
	"./info-journey-en.gif": 2516,
	"./info-journey.gif": 2517,
	"./info-new-mail.gif": 2518,
	"./info-password-security.gif": 2519,
	"./info-wifi.gif": 2520,
	"./it-gif1.gif": 2521,
	"./it-gif2.gif": 2522,
	"./it-gif3.gif": 2523,
	"./it-gif4.gif": 2524,
	"./it900-a031-en.jpg": 959,
	"./it900-a031.jpg": 960,
	"./it900-a32-1.jpg": 961,
	"./it900-a32-2.jpg": 962,
	"./it900-a32-3.jpg": 963,
	"./it930-a033-1.jpg": 964,
	"./it930-a033-2.jpg": 965,
	"./it930-a033-3.jpg": 966,
	"./it930-a033-4.jpg": 967,
	"./it930-a033-5-en.jpg": 968,
	"./it930-a033-5.jpg": 969,
	"./lady-right-01.png": 2525,
	"./lady-right.jpg": 970,
	"./lady-right.png": 2526,
	"./landingbg.png": 2527,
	"./logo.png": 2528,
	"./logo/consumer.png": 2529,
	"./logo/cpttm.png": 2530,
	"./logo/hkgcsmeaa.png": 2531,
	"./logo/logo.png": 2532,
	"./man-left-2.svg": 2533,
	"./man-right-2.png": 2534,
	"./man-right.jpg": 971,
	"./man-right2.png": 2535,
	"./man.jpg": 972,
	"./market-gif1.gif": 2536,
	"./market-gif2.gif": 2537,
	"./market-gif3.gif": 2538,
	"./market-gif4.gif": 2539,
	"./market-notpass.png": 592,
	"./market-quiz-info.png": 593,
	"./meeting.png": 2540,
	"./news-en.png": 2541,
	"./news-mobile-en.jpg": 973,
	"./news-mobile-sc.jpg": 974,
	"./news-mobile.jpg": 975,
	"./news-sc.jpg": 976,
	"./news.jpg": 977,
	"./news.png": 2542,
	"./next-icon.svg": 594,
	"./ngo-a035-1.jpg": 978,
	"./ngo-a035-2.jpg": 979,
	"./ngo-a035-3.jpg": 980,
	"./ngo-a035-4.jpg": 981,
	"./ngo-a036-example-en.png": 2543,
	"./ngo-a036-example.jpg": 982,
	"./ngo-gif1.gif": 2544,
	"./ngo-gif2.gif": 2545,
	"./ngo-gif3.gif": 2546,
	"./ngo-gif4.gif": 2547,
	"./notpass.png": 2548,
	"./office-risk1.png": 2549,
	"./office-risk2.png": 2550,
	"./office-risk3.png": 2551,
	"./office-risk4.png": 2552,
	"./office-risk5.png": 2553,
	"./org-brand1.png": 2554,
	"./ornament.png": 248,
	"./p-completed.svg": 2555,
	"./p-notstart.svg": 2556,
	"./p-onprogress-B.jpg": 983,
	"./p-onprogress-E-commerce.png": 2557,
	"./p-onprogress-b.png": 2558,
	"./p-onprogress-cs.png": 2559,
	"./p-onprogress-fsi.png": 2560,
	"./p-onprogress-g.png": 2561,
	"./p-onprogress-general2024.png": 2562,
	"./p-onprogress-it.png": 2563,
	"./p-onprogress-ngo.png": 2564,
	"./p-onprogress-startup.png": 2565,
	"./p-onprogress-student.png": 2566,
	"./p-onprogress.svg": 2567,
	"./p9801.png": 249,
	"./pass.png": 595,
	"./phishing-indentify1.png": 2568,
	"./phishing-indentify2.png": 2569,
	"./phishing-indentify3.png": 2570,
	"./phishing-indentify4-en.png": 2571,
	"./phishing-indentify4.png": 2572,
	"./phishing-indentify5.png": 2573,
	"./phishing-indentify6.png": 2574,
	"./phishing1.png": 2575,
	"./phishing2.png": 2576,
	"./phishing3.png": 2577,
	"./phishing4.png": 2578,
	"./phishingicon1.png": 2579,
	"./phishingicon2.png": 2580,
	"./phishingicon3.png": 2581,
	"./phishingicon4.png": 2582,
	"./plus.png": 117,
	"./popover-red.png": 2583,
	"./popover.png": 2584,
	"./popup1.png": 2585,
	"./prev-icon.svg": 2586,
	"./pwc-logo-dark.png": 2587,
	"./pwc-logo-dark.svg": 2588,
	"./pwc-logo-white.png": 2589,
	"./pwc-logo-white.svg": 2590,
	"./pwc-logo.png": 2591,
	"./pwc-logo.svg": 2592,
	"./quiz-icon.png": 207,
	"./quiz-info.png": 2593,
	"./quizbg.png": 2594,
	"./ransomewareRealcase-en.png": 2595,
	"./ransomewareRealcase-mobile-en.png": 2596,
	"./ransomewareRealcase-mobile.png": 2597,
	"./ransomewareRealcase.png": 2598,
	"./ransomware.png": 2599,
	"./results1.png": 2600,
	"./results2.png": 2601,
	"./results3.png": 2602,
	"./results4.png": 2603,
	"./s3-001.png": 2604,
	"./s3-002.png": 2605,
	"./s3-003.png": 2606,
	"./s3-004.jpg": 984,
	"./s3-005.jpg": 985,
	"./s3-006.jpg": 986,
	"./s3-007.jpg": 987,
	"./s3-008.jpg": 988,
	"./sample.png": 2607,
	"./secure-warning-bg.png": 2608,
	"./secure-warning1.png": 2609,
	"./secure-warning2.png": 2610,
	"./senior-sample1.png": 2611,
	"./senior-sample10.png": 2612,
	"./senior-sample2.png": 2613,
	"./senior-sample3-sc.png": 2614,
	"./senior-sample3.png": 2615,
	"./senior-sample4.png": 2616,
	"./senior-sample5.png": 2617,
	"./senior-sample6.png": 2618,
	"./senior-sample7.png": 2619,
	"./senior-sample8.png": 2620,
	"./senior-sample9.png": 2621,
	"./service.png": 596,
	"./small-icon1.png": 2622,
	"./small-icon10.png": 2623,
	"./small-icon2.png": 2624,
	"./small-icon3.png": 2625,
	"./small-icon4.png": 2626,
	"./small-icon5.png": 2627,
	"./small-icon6.png": 2628,
	"./small-icon7.png": 2629,
	"./small-icon8.png": 2630,
	"./small-icon9.png": 2631,
	"./social-media-bg-g.png": 2632,
	"./social-media-bg.png": 2633,
	"./social-media.gif": 76,
	"./socialMedia.png": 2634,
	"./sponsor-logo/1.png": 989,
	"./sponsor-logo/10.png": 990,
	"./sponsor-logo/11.png": 991,
	"./sponsor-logo/12.png": 992,
	"./sponsor-logo/13.png": 993,
	"./sponsor-logo/14.png": 994,
	"./sponsor-logo/15.png": 995,
	"./sponsor-logo/16.png": 996,
	"./sponsor-logo/17.png": 997,
	"./sponsor-logo/18.png": 998,
	"./sponsor-logo/19.png": 999,
	"./sponsor-logo/2.png": 1000,
	"./sponsor-logo/20.png": 1001,
	"./sponsor-logo/21.png": 1002,
	"./sponsor-logo/22.png": 1003,
	"./sponsor-logo/23.png": 1004,
	"./sponsor-logo/24.png": 1005,
	"./sponsor-logo/25.png": 1006,
	"./sponsor-logo/26.png": 1007,
	"./sponsor-logo/27.png": 1008,
	"./sponsor-logo/28.png": 1009,
	"./sponsor-logo/29.png": 1010,
	"./sponsor-logo/3.png": 1011,
	"./sponsor-logo/30.png": 1012,
	"./sponsor-logo/4.png": 1013,
	"./sponsor-logo/5.png": 1014,
	"./sponsor-logo/6.png": 1015,
	"./sponsor-logo/7.png": 1016,
	"./sponsor-logo/8.png": 1017,
	"./sponsor-logo/9.png": 1018,
	"./sponsor-logo/more1.png": 1019,
	"./startup1.gif": 2635,
	"./startup2.gif": 2636,
	"./startup3.gif": 2637,
	"./startup4.gif": 2638,
	"./startupRealCase1-en.jpg": 1020,
	"./startupRealCase1-mobile-en.jpg": 1021,
	"./startupRealCase1-mobile.jpg": 1022,
	"./startupRealCase1.jpg": 1023,
	"./startupRealCase2-en.jpg": 1024,
	"./startupRealCase2-mobile-en.jpg": 1025,
	"./startupRealCase2-mobile.jpg": 1026,
	"./startupRealCase2.jpg": 1027,
	"./step-c-1.png": 57,
	"./step-c-2.png": 58,
	"./step-c-3.png": 59,
	"./step-i-1.png": 2639,
	"./step-i-2.png": 2640,
	"./step-i-3.png": 2641,
	"./step-i-4.png": 2642,
	"./student.svg": 2643,
	"./student1.gif": 2644,
	"./student2.gif": 2645,
	"./student3.gif": 2646,
	"./student4.gif": 2647,
	"./studentRealCase1-en.png": 2648,
	"./studentRealCase1-mobile-en.png": 2649,
	"./studentRealCase1-mobile-sc.jpg": 1028,
	"./studentRealCase1-mobile.png": 2650,
	"./studentRealCase1-sc.jpg": 1029,
	"./studentRealCase1.png": 2651,
	"./studentRealCase2-en.png": 2652,
	"./studentRealCase2-mobile-en.png": 2653,
	"./studentRealCase2-mobile-sc.jpg": 1030,
	"./studentRealCase2-mobile.png": 2654,
	"./studentRealCase2-sc.jpg": 1031,
	"./studentRealCase2.png": 2655,
	"./support-org1.png": 2656,
	"./support-org2.png": 2657,
	"./support-org3.png": 2658,
	"./support-org4.png": 2659,
	"./test046.png": 2660,
	"./tip-arrow.png": 2661,
	"./tip1.png": 2662,
	"./tip2.png": 2663,
	"./tip3.png": 2664,
	"./tip4.png": 2665,
	"./tip5.png": 2666,
	"./tipbg.png": 2667,
	"./tips-person.png": 162,
	"./tips-person.svg": 2668,
	"./topic1.png": 2669,
	"./topic1200.png": 2670,
	"./topic1200bg.png": 2671,
	"./topic1400.png": 2672,
	"./topic1400bg.png": 2673,
	"./topic2.png": 2674,
	"./topic3.png": 2675,
	"./topic4.png": 2676,
	"./topic6.png": 2677,
	"./topic7.png": 2678,
	"./topic900.png": 2679,
	"./topic900bg.png": 2680,
	"./topic930.png": 2681,
	"./topic930bg.png": 2682,
	"./training-illustration.png": 2683,
	"./training-illustration10.png": 2684,
	"./training-illustration11.png": 2685,
	"./training-illustration12.png": 2686,
	"./training-illustration13.png": 2687,
	"./training-illustration2.png": 2688,
	"./training-illustration20.png": 2689,
	"./training-illustration25.png": 2690,
	"./training-illustration26.png": 2691,
	"./training-illustration3.png": 2692,
	"./training-illustration4.svg": 2693,
	"./training-illustration5.svg": 2694,
	"./training-illustration6.svg": 2695,
	"./training-illustration7.png": 2696,
	"./training-illustration8.png": 2697,
	"./training-illustration9.png": 2698,
	"./transcrip.png": 208,
	"./unhappy-emoji.png": 141,
	"./useful-link-Icon.png": 2699,
	"./vector.png": 2700,
	"./vector137.png": 2701,
	"./video1-en.mp4": 2702,
	"./video1.mp4": 2703,
	"./video1more.mp4": 2704,
	"./video2.mp4": 2705,
	"./warning-alert-bg.png": 2706,
	"./warning-alert-bg2.png": 2707,
	"./welc1.gif": 2708,
	"./welc2.gif": 2709,
	"./welc3.gif": 2710,
	"./welc4.gif": 2711,
	"./welcome.gif": 2712,
	"./welcomeInfo.png": 2713,
	"./welcomeInfo2.png": 2714,
	"./welcomeInfo3.png": 2715,
	"./welcomeLandingbg-E-commerce.png": 2716,
	"./welcomeLandingbg-fsi.png": 2717,
	"./welcomeLandingbg-general2024.png": 2718,
	"./welcomeLandingbg-it.png": 2719,
	"./welcomeLandingbg-ngo.png": 2720,
	"./welcomeLandingbg-startup.png": 2721,
	"./welcomeLandingbg-student.png": 2722,
	"./welcomeLandingbg.png": 2723,
	"./whatsApp.png": 2724,
	"./whatsAppRealcase-en-mobile.png": 2725,
	"./whatsAppRealcase-en.png": 2726,
	"./whatsAppRealcase-mobile.png": 2727,
	"./whatsAppRealcase.png": 2728,
	"./working.png": 2729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;